﻿(function () {
  'use strict';
  function ufcSubDetailCustomerEmail() {
    var el = document.getElementById('sub-detail-load-by-id') || document.getElementById('account-ufc-subscription-detail-wrap');
    return el && el.getAttribute('data-customer-email') ? String(el.getAttribute('data-customer-email')) : '';
  }
  function ufcSubDetailShopOrigin() {
    var el = document.getElementById('sub-detail-load-by-id') || document.getElementById('account-ufc-subscription-detail-wrap');
    var v = el && el.getAttribute('data-shop-origin');
    return v ? String(v) : '';
  }
  function ufcSubDetailPaymentUpdateUrl() {
    var el = document.getElementById('sub-detail-load-by-id') || document.getElementById('account-ufc-subscription-detail-wrap');
    var v = el && el.getAttribute('data-payment-update-url');
    return v ? String(v) : '';
  }
  function parseApiResponse(response) {
    return response.text().then(function(rawText) {
      var text = String(rawText || '').trim();
      if (!text) {
        return { ok: response.ok, status: response.status, data: {} };
      }
      try {
        var parsed = JSON.parse(text);
        return { ok: response.ok, status: response.status, data: parsed || {} };
      } catch (e) {
        var isHtml = text.charAt(0) === '<';
        var message = isHtml
          ? ('Server returned HTML instead of JSON (HTTP ' + response.status + ').')
          : ('Server returned invalid JSON (HTTP ' + response.status + ').');
        return { ok: false, status: response.status, data: { ok: false, error: message } };
      }
    });
  }
  function normalizeRequestError(err) {
    var raw = err && err.message ? String(err.message) : String(err || '');
    if (raw && raw.toLowerCase().indexOf('expected pattern') >= 0) {
      return new Error('Request failed before reaching server (Safari URL parsing issue). Please refresh and try again.');
    }
    if (raw && raw.toLowerCase().indexOf('failed to fetch') >= 0) {
      return new Error('Network request failed. Please check your connection and try again.');
    }
    return err instanceof Error ? err : new Error(raw || 'Network error.');
  }
  function toAbsoluteUrl(url) {
    var u = String(url || '').trim();
    if (!u) return window.location.origin + '/';
    if (/^https?:\/\//i.test(u) || /^\/\//.test(u)) return u;
    if (u.charAt(0) !== '/') u = '/' + u;
    return String(window.location.origin || '').replace(/\/$/, '') + u;
  }
  function fetchJsonWithFallback(url, init, timeoutMs) {
    var requester = window.ufcFetchWithTimeout || fetch;
    return requester(url, init, timeoutMs)
      .then(parseApiResponse)
      .catch(function(err) {
        var msg = err && err.message ? String(err.message).toLowerCase() : '';
        var shouldRetry = msg.indexOf('expected pattern') >= 0;
        if (!shouldRetry) throw normalizeRequestError(err);
        return fetch(toAbsoluteUrl(url), init || {})
          .then(parseApiResponse)
          .catch(function(err2) {
            throw normalizeRequestError(err2);
          });
      });
  }
  async function fetchJsonWithPathFallback(paths, init, timeoutMs) {
    var list = Array.isArray(paths) ? paths.filter(Boolean) : [paths];
    if (!list.length) throw new Error('No request path configured.');
    var lastResult = null;
    var lastErr = null;
    for (var i = 0; i < list.length; i++) {
      var path = list[i];
      try {
        var result = await fetchJsonWithFallback(path, init, timeoutMs);
        lastResult = result;
        if (result && result.ok) return result;
        var code = String(result && result.data && result.data.error ? result.data.error : '').toLowerCase();
        var retryable = (result && result.status >= 500) || code === 'internal_error' || code === 'internal_server_error';
        if (!retryable || i === list.length - 1) return result;
      } catch (e) {
        lastErr = normalizeRequestError(e);
        if (i === list.length - 1) throw lastErr;
      }
    }
    if (lastResult) return lastResult;
    throw (lastErr || new Error('Request failed.'));
  }

      (function(){
        var wrap = document.getElementById('sub-detail-load-by-id');
        if (!wrap) return;
        var orderUrls = {};
        var orderPlans = {};
        try {
          var orderUrlsEl = document.getElementById('sub-detail-order-urls-map');
          if (orderUrlsEl && orderUrlsEl.textContent) {
            var parsed = JSON.parse(orderUrlsEl.textContent);
            if (parsed && parsed.orderUrls) orderUrls = parsed.orderUrls;
          }
          var orderPlansEl = document.getElementById('sub-detail-order-plan-map');
          if (orderPlansEl && orderPlansEl.textContent) {
            var parsed2 = JSON.parse(orderPlansEl.textContent);
            if (parsed2 && parsed2.orderPlans) orderPlans = parsed2.orderPlans;
          }
        } catch (e) {}
        var subId = (new URLSearchParams(window.location.search || '')).get('subscription');
        if (subId != null) subId = String(subId).trim().replace(/^#/, ''); else subId = '';
        var apiUrl = (wrap.getAttribute('data-api-url') || '').trim();
        var fallbackUrl = (wrap.getAttribute('data-fallback-api-url') || '').trim();
        var apiKey = (wrap.getAttribute('data-api-key') || '').trim();
        var backUrl = (wrap.getAttribute('data-back-url') || '/pages/subscriptions').trim();
        var paymentUpdateUrl = (wrap.getAttribute('data-payment-update-url') || '').trim();
        var useCredentials = wrap.getAttribute('data-use-credentials') === 'true';
        if (!subId) {
          wrap.innerHTML = '<p>No subscription ID in URL.</p><a href="' + backUrl + '">Back to Subscriptions</a>';
          return;
        }
        if (!apiUrl && !fallbackUrl) {
          wrap.innerHTML = '<p>Subscription not found.</p><a href="' + backUrl + '">Back to Subscriptions</a>';
          return;
        }
        var CACHE_KEY = 'ufc_subs_cache';
        var CACHE_MAX_AGE = 5 * 60 * 1000;
        function tryRenderFromCache() {
          try {
            var raw = sessionStorage.getItem(CACHE_KEY);
            if (!raw) return false;
            var obj = JSON.parse(raw);
            if (!obj || !obj.data || (Date.now() - (obj.t || 0)) >= CACHE_MAX_AGE) return false;
            return renderFromData(obj.data, 'Cache', '');
          } catch (e) { return false; }
        }
        function extractId(obj) {
          if (!obj) return '';
          var v = obj.subscriptionContractId != null ? String(obj.subscriptionContractId) : (obj.id != null ? String(obj.id) : (obj.contract_id != null ? String(obj.contract_id) : (obj.contractId != null ? String(obj.contractId) : '')));
          v = v.replace(/^#/, '').trim();
          var m = v.match(/SubscriptionContract\/(\d+)/) || v.match(/\/(\d+)$/);
          return m ? m[1] : (v.match(/^\d+$/) ? v : v);
        }
        function formatDate(iso) {
          if (!iso || typeof iso !== 'string') return '—';
          var d = new Date(iso);
          if (isNaN(d.getTime())) return iso;
          var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()];
          return m + ' ' + d.getDate() + ', ' + d.getFullYear();
        }
        function formatMoney(amount, code) {
          if (amount == null || isNaN(amount)) return '—';
          var c = (code || 'USD').toUpperCase();
          return '$' + Number(amount).toFixed(2) + ' ' + c;
        }
        /** 与 Orders 列表卡一致：Appstle 续订折扣（GovX / UFC Tier 等） */
        function buildDetailPriceInnerHtml(regularFmt, currencyCode, discountedTotal, discountCode) {
          if (discountedTotal != null && discountCode && !isNaN(Number(discountedTotal))) {
            var discFmt = formatMoney(Number(discountedTotal), currencyCode);
            return '<span class="sub-detail-v2__price-wrap">' +
              '<span class="sub-detail-v2__price--original">' + String(regularFmt).replace(/</g, '&lt;') + '</span>' +
              '<span class="sub-detail-v2__price--discounted">' + String(discFmt).replace(/</g, '&lt;') + '</span>' +
              '</span>';
          }
          return String(regularFmt).replace(/</g, '&lt;');
        }
        function applyRenewalDisplayPriceToDetail(wrapEl, contractId, currencyCode, mealCount, fallbackRegularFmt) {
          var email = ufcSubDetailCustomerEmail();
          if (!wrapEl || !email || !contractId) return;
          var want = String(contractId).replace(/\D/g, '');
          fetchJsonWithPathFallback([
            '/apps/ufc-ignite?action=upcoming-subscription-orders',
            '/apps/ufc-ignite/signup-and-invite?action=upcoming-subscription-orders',
          ], {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'upcoming-subscription-orders', customerEmail: email }),
          }, 25000).then(function(result) {
            if (!result.ok || !result.data || !result.data.ok || !Array.isArray(result.data.orders)) return;
            var row = null;
            for (var i = 0; i < result.data.orders.length; i++) {
              var o = result.data.orders[i];
              if (String(o.contractId || '').replace(/\D/g, '') === want) { row = o; break; }
            }
            if (!row) return;
            var priceEl = wrapEl.querySelector('.sub-detail-v2__stat-value--price');
            if (!priceEl) return;
            var base = row.contractAmount != null ? Number(row.contractAmount) : (row.subtotal != null ? Number(row.subtotal) : NaN);
            var regularFmt = !isNaN(base) ? formatMoney(base, row.currencyCode || currencyCode) : fallbackRegularFmt;
            var suffix = mealCount ? ' (' + mealCount + ' meals/week)' : '';
            priceEl.innerHTML = buildDetailPriceInnerHtml(regularFmt, row.currencyCode || currencyCode, row.discountedTotal, row.discountCode) + suffix;
          }).catch(function() { /* 静默回退原价 */ });
        }
        /**
         * UFC 送达日：见 assets/ufc-delivery-date.js（PT 扣款周二锚定 +3 = 周五）
         */
        function billingTuesdayToDeliveryPacific(billingIso) {
          if (window.UfcDeliveryDate && UfcDeliveryDate.billingTuesdayToDeliveryPacific) {
            return UfcDeliveryDate.billingTuesdayToDeliveryPacific(billingIso);
          }
          return null;
        }
        /** 今天（PT 日历）与目标日（PT 日历）相差几天 */
        function ptCalendarDaysFromTodayTo(targetDate) {
          if (!targetDate || isNaN(targetDate.getTime())) return null;
          var aYmd = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Los_Angeles' });
          var bYmd = targetDate.toLocaleDateString('en-CA', { timeZone: 'America/Los_Angeles' });
          var a = new Date(aYmd + 'T12:00:00Z');
          var b = new Date(bYmd + 'T12:00:00Z');
          return Math.round((b - a) / 86400000);
        }
        /** 与 Orders 页一致：未完结订单的 delivery: / custom.delivery_date，取本周期最早未来送达。
         *  优先匹配订阅号；匹配不到时用 sub:"*" 兜底（绝大多数账号一份订阅，未完结的未来订单即是 next delivery）。 */
        function getEarliestShopifyDeliveryFromPage(idParam, displayId, subscriptionContractIdFromApi) {
          var el = document.getElementById('sub-detail-shopify-delivery-candidates');
          if (!el || !el.textContent) return null;
          var list;
          try { list = JSON.parse(el.textContent); } catch (e) { return null; }
          if (!Array.isArray(list) || list.length === 0) return null;
          var want = [String(idParam || ''), String(displayId || ''), String(subscriptionContractIdFromApi || '')].map(function (x) { return x.replace(/^#/, '').trim(); }).filter(Boolean);
          var wantNum = want.map(function (x) { return x.replace(/\D/g, ''); }).filter(Boolean);
          var bestMatched = null;
          var bestAny = null;
          for (var i = 0; i < list.length; i++) {
            var row = list[i];
            if (!row || row.d == null || row.sub == null) continue;
            var dt = new Date(String(row.d).trim() + 'T12:00:00Z');
            if (isNaN(dt.getTime())) continue;
            if (window.UfcDeliveryDate && UfcDeliveryDate.parseDeliveryTagDatePacific) {
              dt = UfcDeliveryDate.parseDeliveryTagDatePacific(dt);
            }
            var days = ptCalendarDaysFromTodayTo(dt);
            if (days == null || days < 0) continue;
            var rs = String(row.sub).replace(/^#/, '').trim();
            if (rs === '*') {
              if (!bestAny || dt.getTime() < bestAny.getTime()) bestAny = dt;
              continue;
            }
            var match = want.indexOf(rs) >= 0;
            if (!match) {
              var rsn = rs.replace(/\D/g, '');
              for (var wn = 0; wn < wantNum.length; wn++) {
                if (wantNum[wn] && rsn === wantNum[wn]) { match = true; break; }
              }
            }
            if (!match && rs.indexOf('SubscriptionContract') >= 0) {
              var m = rs.match(/SubscriptionContract\/(\d+)/);
              if (m && wantNum.indexOf(m[1]) >= 0) match = true;
            }
            if (!match) continue;
            if (!bestMatched || dt.getTime() < bestMatched.getTime()) bestMatched = dt;
          }
          return bestMatched || bestAny;
        }
        function renderFromData(data, apiSource, requestUrl) {
          if (!data) return false;
          var list = data.content || (Array.isArray(data) ? data : (data.subscriptions || data.contracts || data.subscriptionContracts || data.subscription_contracts || (data.data && (data.data.content || data.data.subscriptions || data.data.contracts)) || []));
          if (!Array.isArray(list)) list = [];
          if (list.length === 0 && data && (data.subscriptionContractId != null || data.importedId || data.id != null)) list = [data];
          var subIdNum = subId.replace(/\D/g, '');
          var s = null;
          for (var i = 0; i < list.length; i++) {
            var id = extractId(list[i]);
            var rawId = list[i].id || list[i].subscriptionContractId || '';
            var imp = list[i].importedId ? String(list[i].importedId).trim() : '';
            if (id === subId || id === subIdNum || imp === subId || String(rawId).replace(/^#/, '').trim() === subId || String(rawId).indexOf(subId) >= 0) {
              s = list[i];
              break;
            }
          }
          if (!s) return false;
          var displayId = (s.importedId && String(s.importedId).trim()) || extractId(s) || subId;
          var status = (s.status || s.contractStatus || '').toLowerCase().trim();
          if (status === 'canceled') status = 'cancelled';
          var statusLabel = status === 'cancelled' ? 'Cancelled' : (status === 'active' ? 'Active' : (status === 'paused' ? 'Paused' : (status.charAt(0).toUpperCase() + status.slice(1))));
          var plan = (s.billingPolicy && s.billingPolicy.intervalCount) ? ('Delivery every ' + s.billingPolicy.intervalCount + ' ' + (s.billingPolicy.interval || 'week').toLowerCase() + '(s)') : ((s.billingPolicyInterval != null && s.billingPolicyIntervalCount != null) ? ('Delivery every ' + s.billingPolicyIntervalCount + ' ' + (s.billingPolicyInterval || 'week').toLowerCase() + '(s)') : (s.sellingPlanName || s.planName || s.orderName || 'Subscription')) || '—';
          var started = (s.activatedOn != null ? s.activatedOn : (s.startsAt != null ? s.startsAt : (s.createdAt != null ? s.createdAt : ''))) || '—';
          var startedFmt = started !== '—' ? formatDate(started) : '—';
          var contractDetails = [];
          try { contractDetails = JSON.parse(s.contractDetailsJSON || '[]'); } catch (e) {}
          var mealCount = 0;
          if (Array.isArray(contractDetails)) {
            for (var mi = 0; mi < contractDetails.length; mi++) {
              var titleMatch = (contractDetails[mi].title || '').match(/(\d+)\s*-?\s*meal/i);
              if (titleMatch) { mealCount += parseInt(titleMatch[1], 10) * (Number(contractDetails[mi].quantity) || 1); }
              else { mealCount += Number(contractDetails[mi].quantity) || 0; }
            }
          }
          var planPrice = s.contractAmount != null ? formatMoney(s.contractAmount, s.currencyCode) : (s.orderAmount != null ? formatMoney(s.orderAmount, s.currencyCode) : '—');
          var planMeta = (startedFmt !== '—' ? 'Started: ' + startedFmt : '') + (mealCount ? (startedFmt ? ' · ' : '') + mealCount + ' meals per week' : '');
          var nextBilling = (s.nextBillingDate || s.next_billing_date) ? formatDate(s.nextBillingDate || s.next_billing_date) : '';
          var pausedOnFmt = (status === 'paused' && s.pausedOn) ? formatDate(s.pausedOn) : '';
          
          // Shipping Address
          var addr = s.deliveryMethod && s.deliveryMethod.address ? s.deliveryMethod.address : (s.billingAddress || s.billing_address || s.shippingAddress || s.shipping_address || (s.deliveryMethod || {}));
          var cust = s.customer || {};
          var name = (s.customerName || (addr.name || (addr.firstName && (addr.firstName + ' ' + (addr.lastName || ''))) || (cust.displayName || (cust.firstName && (cust.firstName + ' ' + (cust.lastName || ''))) || ''))).trim() || '—';
          var addr1 = addr.address1 || addr.line1 || '';
          var addr2 = addr.address2 || addr.line2 || '';
          var city = addr.city || '';
          var province = addr.province || addr.provinceCode || '';
          var zip = addr.zip || addr.postalCode || '';
          var country = addr.country || (s.billingCountryCode || s.deliveryCountryCode || '');
          if (country === 'US') country = 'United States';
          var addrLine = [addr1, addr2].filter(Boolean).join(', ');
          var cityLine = [city, province, zip, country].filter(Boolean).join(', ');
          var backLink = '<a href="' + backUrl + '" class="order-detail-ufc__back" aria-label="Back"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>Back</a>';
          var titleIdEsc = String(displayId).replace(/</g, '&lt;').replace(/>/g, '&gt;');
          var title = '<h1 class="order-detail-ufc__title order-detail-ufc__title--v2"><span class="sub-detail-v2__title-prefix">SUBSCRIPTION #</span><span class="sub-detail-v2__title-id">' + titleIdEsc + '</span></h1>';
          var statusBadge = '<span class="order-detail-ufc__status-badge' + (status === 'active' ? ' order-detail-ufc__status-badge--active' : (status === 'paused' ? ' order-detail-ufc__status-badge--paused' : '')) + '">' + statusLabel + '</span>';
          /* ── 提取 pause 相关 customAttributes ── */
          var _pauseResumeDate = '', _pauseWeeks = 0, _pauseExtTotalWeeks = 0, _pauseExtCount = 0;
          if (Array.isArray(contractDetails)) {
            contractDetails.forEach(function(li) {
              var attrs = li.customAttributes || [];
              attrs.forEach(function(a) {
                if (a.key === 'pause_resume_date') _pauseResumeDate = a.value || '';
                if (a.key === 'pause_weeks') _pauseWeeks = parseInt(a.value, 10) || 0;
                if (a.key === 'pause_extended_total_weeks') _pauseExtTotalWeeks = parseInt(a.value, 10) || 0;
                if (a.key === 'pause_extended_count') _pauseExtCount = parseInt(a.value, 10) || 0;
              });
            });
          }
          var _totalPauseWeeks = _pauseWeeks + _pauseExtTotalWeeks;
          var _maxExtendWeeks = Math.max(0, 8 - _totalPauseWeeks);
          var _maxExtendBtnAttr = Math.min(4, Math.max(1, _maxExtendWeeks));
          var extendBtnHtml = (status === 'paused' && _pauseResumeDate && _maxExtendWeeks > 0) ? '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="extend-pause" data-max-extend="' + _maxExtendBtnAttr + '">EXTEND PAUSE</button>' : '';
          var actionsHtml = '';
          if (status === 'cancelled' || status === 'canceled') {
            actionsHtml = '<div class="order-detail-ufc__sub-actions"><button type="button" class="order-detail-ufc__sub-btn" data-sub-action="resume">RESUME</button></div>';
          } else {
            actionsHtml = '<div class="order-detail-ufc__sub-actions"><button type="button" class="order-detail-ufc__sub-btn" data-sub-action="' + (status === 'paused' ? 'resume' : 'pause') + '">' + (status === 'paused' ? 'RESUME' : 'PAUSE') + '</button>' + extendBtnHtml + '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="cancel">CANCEL</button></div>';
          }
          var topRow = '<div class="order-detail-ufc__top-row"><div class="order-detail-ufc__title-wrap">' + title + statusBadge + '</div>' + actionsHtml + '</div>';
          /* ── 构建 Pause Info Banner（初始加载时） ── */
          var pauseInfoHtml = '';
          if (status === 'paused' && _pauseResumeDate) {
            var _rd = new Date(_pauseResumeDate);
            var _now = new Date();
            var _daysLeft = Math.max(0, Math.ceil((_rd - _now) / 86400000));
            var _rdFmt = _rd.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
            pauseInfoHtml =               '<div class="pause-info-banner" id="pause-info-banner">' +
              '<div class="pause-info-banner__label">⏸ Subscription Paused</div>' +
              '<div><strong>Resumes:</strong> ' + _rdFmt + ' (' + _daysLeft + ' days remaining)</div>' +
              '</div>';
          }
          var planLabel = '';
          try {
            var lastOrderForPlan = JSON.parse(s.lastSuccessfulOrder || 'null');
            if (lastOrderForPlan && lastOrderForPlan.orderId != null) {
              planLabel = orderPlans[String(lastOrderForPlan.orderId)] || '';
            }
          } catch (e) {}
          if (planLabel) planLabel = String(planLabel).trim();
          var planDisplay = planLabel ? planLabel : (plan !== '—' ? plan : 'Subscription');
          /* 提前提取 selectedVariants 以便传递给 edit-meals 页面 */
          var _selectedVariantsForUrl = '';
          if (Array.isArray(contractDetails)) {
            contractDetails.forEach(function(li) {
              var attrs = li.customAttributes || [];
              attrs.forEach(function(a) {
                if (a.key === '_selected_variants') _selectedVariantsForUrl = a.value || '';
              });
            });
          }
          /* 构建跳转到 edit-meals 页面的 URL（goal 优先从 Selling Plan / 合约行 / 属性推断，避免默认 cut） */
          var editMealsBaseUrl = '/pages/edit-meals';
          var editMealsGoal = (function inferEditMealsGoal() {
            function goalFromText(blob) {
              if (!blob || !String(blob).trim()) return null;
              var t = String(blob).toLowerCase();
              if (/\bmix\s*&\s*match\b/.test(t) || /\bmix and match\b/.test(t) || /mix-match/.test(t) || (/\bmix\b/.test(t) && /\bmatch\b/.test(t))) return 'mix';
              if (/\bmaintain\b/.test(t) || t.indexOf('maintain') !== -1) return 'maintain';
              if (/\bbuild\b/.test(t) || t.indexOf('build') !== -1) return 'build';
              if (/\bcut\b/.test(t) || /\blite\b/.test(t) || t.indexOf('lite') !== -1) return 'cut';
              if (t.indexOf('cut') !== -1) return 'cut';
              return null;
            }
            var primary = [];
            if (s.sellingPlanName) primary.push(String(s.sellingPlanName));
            if (s.planName) primary.push(String(s.planName));
            if (s.sellingPlan && typeof s.sellingPlan === 'object') {
              if (s.sellingPlan.name) primary.push(String(s.sellingPlan.name));
              if (s.sellingPlan.sellingPlanName) primary.push(String(s.sellingPlan.sellingPlanName));
            }
            try {
              if (s.tags && Array.isArray(s.tags)) {
                s.tags.forEach(function(tag) { if (tag) primary.push(String(tag)); });
              }
            } catch (e) {}
            try {
              if (Array.isArray(contractDetails)) {
                contractDetails.forEach(function(li) {
                  if (li && li.title) primary.push(String(li.title));
                  if (li && li.variantTitle) primary.push(String(li.variantTitle));
                  if (li && li.productTitle) primary.push(String(li.productTitle));
                  if (li && li.product && li.product.title) primary.push(String(li.product.title));
                  var attrs = li.customAttributes || li.custom_attributes || [];
                  attrs.forEach(function(a) {
                    var k = (a.key || a.name || '').toLowerCase();
                    if (k === 'goal' || k === 'meal_plan' || k === 'plan' || k === '_goal') {
                      if (a.value) primary.push(String(a.value));
                    }
                  });
                });
              }
            } catch (e) {}
            try {
              var topAttrs = s.customAttributes || s.attributes || s.customFields;
              if (typeof topAttrs === 'string') try { topAttrs = JSON.parse(topAttrs); } catch (e2) { topAttrs = null; }
              if (Array.isArray(topAttrs)) {
                topAttrs.forEach(function(a) {
                  var k = (a.key || a.name || '').toLowerCase();
                  if ((k === 'goal' || k === 'meal_plan' || k === 'plan') && a.value) primary.push(String(a.value));
                });
              }
            } catch (e) {}
            var gPrimary = goalFromText(primary.join(' | '));
            if (gPrimary) return gPrimary;
            var secondary = [];
            if (planLabel) secondary.push(String(planLabel));
            if (planDisplay) secondary.push(String(planDisplay));
            secondary.push(String(plan));
            var gSecondary = goalFromText(secondary.join(' | '));
            if (gSecondary) return gSecondary;
            return 'cut';
          })();
          var editMealsContractId = (s.subscriptionContractId != null ? String(s.subscriptionContractId) : (s.id != null ? String(s.id) : extractId(s))) || '';
          var editMealsAllergens = '';
          try { var _attrs = s.attributes || s.customFields || s.customFieldValues || {}; if (typeof _attrs === 'string') _attrs = JSON.parse(_attrs); editMealsAllergens = (_attrs.allergens || _attrs.Allergens || '').toString().trim(); } catch(e) {}
          var editMealsUrl = editMealsBaseUrl + '?contractId=' + encodeURIComponent(editMealsContractId) + '&goal=' + encodeURIComponent(editMealsGoal) + '&meals=' + encodeURIComponent(mealCount || 4) + (editMealsAllergens ? '&allergens=' + encodeURIComponent(editMealsAllergens) : '') + (_selectedVariantsForUrl ? '&selectedVariants=' + encodeURIComponent(_selectedVariantsForUrl) : '') + '&back=' + encodeURIComponent(window.location.href);
          window.__ufcEditMealsUrl = editMealsUrl;
          var nextDelLong = '—';
          var nextDaysPill = '';
          var _shipForNext = null;
          var _candShips = [];
          var _nbIso = s.nextBillingDate || s.next_billing_date;
          var _noIso = s.nextOrderDate || s.next_order_date;
          if (_nbIso) {
            var _c1 = billingTuesdayToDeliveryPacific(_nbIso);
            if (_c1) _candShips.push(_c1);
          }
          if (_noIso && String(_noIso).trim() !== String(_nbIso || '').trim()) {
            var _c2 = billingTuesdayToDeliveryPacific(_noIso);
            if (_c2) _candShips.push(_c2);
          }
          var _cidApi = s.subscriptionContractId != null ? String(s.subscriptionContractId) : '';
          var _shopHint = getEarliestShopifyDeliveryFromPage(subId, displayId, _cidApi);
          if (_shopHint) _candShips.push(_shopHint);
          for (var _csi = 0; _csi < _candShips.length; _csi++) {
            var _cand = _candShips[_csi];
            if (!_cand || isNaN(_cand.getTime())) continue;
            var _dcf = ptCalendarDaysFromTodayTo(_cand);
            if (_dcf == null || _dcf < 0) continue;
            if (!_shipForNext || _cand.getTime() < _shipForNext.getTime()) _shipForNext = _cand;
          }
          if (_shipForNext && !isNaN(_shipForNext.getTime())) {
            nextDelLong = _shipForNext.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric', timeZone: 'America/Los_Angeles' });
            var _ndays = ptCalendarDaysFromTodayTo(_shipForNext);
            if (_ndays == null) _ndays = 0;
            if (_ndays < 0) _ndays = 0;
            nextDaysPill = '<span class="sub-detail-v2__next-pill">' + _ndays + ' day' + (_ndays === 1 ? '' : 's') + ' away</span>';
          }
          if (nextDelLong === '—' && nextBilling) nextDelLong = nextBilling;
          var escPlanDisplay = String(planDisplay).replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
          var planStatText = mealCount ? (mealCount + ' Meals Per Week') : escPlanDisplay;
          var priceStatSuffix = (mealCount && planPrice !== '—') ? ' (' + mealCount + ' meals/week)' : '';
          var priceStatInner = (planPrice !== '—' ? planPrice : '—');
          var statsHtml = '<div class="sub-detail-v2__stats"><div><p class="sub-detail-v2__stat-label">PLAN</p><p class="sub-detail-v2__stat-value">' + planStatText + '</p></div><div><p class="sub-detail-v2__stat-label">STARTED AT</p><p class="sub-detail-v2__stat-value">' + String(startedFmt).replace(/</g, '&lt;') + '</p></div><div><p class="sub-detail-v2__stat-label">PRICE</p><p class="sub-detail-v2__stat-value sub-detail-v2__stat-value--price">' + String(priceStatInner + priceStatSuffix).replace(/</g, '&lt;') + '</p></div></div>';
          var manageOpen = (status !== 'cancelled' && status !== 'canceled');
          var planTileHtml = '<a class="sub-detail-v2__manage-tile" href="' + editMealsUrl.replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '"><span class="sub-detail-v2__manage-tile-text">Change plan setting</span><span class="sub-detail-v2__manage-tile-chevron" aria-hidden="true">›</span></a>';
          var addressUrl = (wrap.getAttribute('data-address-url') || '/account').trim();
          var manageHtml = '<div class="sub-detail-v2__manage"><p class="sub-detail-v2__manage-label">MANAGE SUBSCRIPTION</p>' + (manageOpen ? '<div class="sub-detail-v2__manage-row">' + planTileHtml + '<button type="button" class="sub-detail-v2__manage-tile" data-manage-action="allergen"><span class="sub-detail-v2__manage-tile-text">Update allergens</span><span class="sub-detail-v2__manage-tile-chevron" aria-hidden="true">›</span></button><button type="button" class="sub-detail-v2__manage-tile" data-manage-action="payment"><span class="sub-detail-v2__manage-tile-text">Update payment method</span><span class="sub-detail-v2__manage-tile-chevron" aria-hidden="true">›</span></button><a class="sub-detail-v2__manage-tile" href="' + addressUrl + '"><span class="sub-detail-v2__manage-tile-text">Update address</span><span class="sub-detail-v2__manage-tile-chevron" aria-hidden="true">›</span></a></div>' : '<p style="font-size:14px;color:#6b7280;margin:0;">This subscription is cancelled.</p>') + '</div>';
          var v2NextRow = '<div><p class="sub-detail-v2__next-label">NEXT DELIVERY</p><p class="sub-detail-v2__next-date">' + String(nextDelLong).replace(/</g, '&lt;') + '</p></div>' + (nextDaysPill ? '<div style="align-self:center;">' + nextDaysPill + '</div>' : '<div></div>');
          var billAddr = s.billingAddress || s.billing_address || {};
          var billName = ((billAddr.firstName || '') + ' ' + (billAddr.lastName || '')).trim() || name;
          var billAddr1 = billAddr.address1 || billAddr.line1 || '';
          var billAddr2 = billAddr.address2 || billAddr.line2 || '';
          var billCity = billAddr.city || '';
          var billProv = billAddr.province || billAddr.provinceCode || '';
          var billZip = billAddr.zip || billAddr.postalCode || '';
          var billCountry = billAddr.country || '';
          if (billCountry === 'US') billCountry = 'United States';
          var billAddrLine = [billAddr1, billAddr2].filter(Boolean).join(', ');
          var billCityLine = [billCity, billProv, billZip, billCountry].filter(Boolean).join(', ');
          var hasBillData = !!(billAddr1 || billCity);
          var grid = '<div class="order-detail-ufc__grid"><div class="order-detail-ufc__block"><h3>Billing Address</h3><p class="name">' + (hasBillData ? billName : name) + '</p><p>' + (hasBillData ? (billAddrLine || '—') : (addrLine || '—')) + '</p><p>' + (hasBillData ? (billCityLine || '—') : (cityLine || '—')) + '</p></div><div class="order-detail-ufc__block"><h3>Shipping Address</h3><p class="name">' + name + '</p><p>' + (addrLine || '—') + '</p><p>' + (cityLine || '—') + '</p></div></div>';
          var paymentUpdateBtnHtml = '<div class="sub-detail-v2__sr-only"><button type="button" class="sub-detail__btn" id="paymentUpdateBtn" style="cursor:pointer;">Update payment method</button><div id="paymentUpdateMsg" style="display:none;"></div></div>';
          var allergenLabels = ['Wheat','Soy','Milk','Egg','Sesame','Peanut','Fish','Tree Nut','Shellfish'];
          function dedupeAllergenList(list) {
            var seen = {};
            var out = [];
            (list || []).forEach(function(v) {
              var t = String(v || '').trim();
              if (!t) return;
              var key = t.toLowerCase();
              if (seen[key]) return;
              seen[key] = true;
              out.push(t);
            });
            return out;
          }
          var attrs = s.attributes || s.customFields || s.customFieldValues || {};
          if (typeof attrs === 'string') try { attrs = JSON.parse(attrs); } catch(e) { attrs = {}; }
          var allergenStr = (attrs.allergens || attrs.Allergens || '').toString().trim();
          var allergenSelectedList = allergenStr ? allergenStr.split(',').map(function(x){ return x.trim(); }).filter(Boolean) : [];
          for (var cb = 0; cb < allergenLabels.length; cb++) {
            var key = 'Avoid ' + allergenLabels[cb];
            if (attrs[key] === true || attrs[key] === 'true' || attrs[key] === '1' || attrs[key] === 'yes') allergenSelectedList.push(allergenLabels[cb]);
          }
          allergenSelectedList = dedupeAllergenList(allergenSelectedList);
          if (allergenSelectedList.length === 0 && (s.contractDetailsJSON || contractDetails)) {
            var cd = contractDetails;
            if (typeof s.contractDetailsJSON === 'string') try { cd = JSON.parse(s.contractDetailsJSON); } catch(e) { cd = contractDetails; }
            var lines = (cd && cd.lines && (cd.lines.nodes || (cd.lines.edges && cd.lines.edges.map(function(e){ return e && e.node; })) || cd.lines)) || (Array.isArray(cd) ? cd : []);
            var listLines = Array.isArray(lines) ? lines : (lines && lines.nodes ? lines.nodes : []);
            var merged = [];
            listLines.forEach(function(line) {
              var lineAttrs = (line && (line.customAttributes || line.custom_attributes)) || [];
              var aAttr = lineAttrs.find ? lineAttrs.find(function(a){ return (a.key || a.name) === 'allergens'; }) : (lineAttrs.filter && lineAttrs.filter(function(a){ return (a.key || a.name) === 'allergens'; })[0]);
              if (!aAttr || !(aAttr.value || aAttr.val)) return;
              var fromLine = (aAttr.value || aAttr.val || '').toString().trim();
              if (!fromLine) return;
              fromLine.split(',').forEach(function(x) {
                var t = x.trim();
                if (t) merged.push(t);
              });
            });
            allergenSelectedList = dedupeAllergenList(merged);
          }
          var allergenHtml = '<div class="sub-detail__section" id="sub-detail-allergens-api" style="margin-top:8px !important;margin-bottom:6px !important;margin-left:0 !important;margin-right:auto !important;padding:0 !important;"><h2 class="sub-detail__section-title" style="margin:0 0 12px 0 !important;padding:0 !important;line-height:1.2 !important;font-size:18px !important;">Avoid allergens</h2><div class="sub-detail__allergen-grid" role="group" aria-label="Select allergens to avoid" style="margin:0 !important;padding:0 !important;">';
          for (var a = 0; a < allergenLabels.length; a++) {
            var label = allergenLabels[a];
            var isSel = allergenSelectedList.indexOf(label) >= 0;
            allergenHtml += '<button type="button" class="sub-detail__allergen-pill' + (isSel ? ' is-selected' : '') + '" data-allergen="' + label.replace(/"/g, '&quot;') + '" aria-pressed="' + (isSel ? 'true' : 'false') + '" style="margin:0 !important;">' + label.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</button>';
          }
          allergenHtml += '</div><div class="sub-detail__allergen-actions" style="margin:14px 0 0 0 !important;padding:0 !important;"><button type="button" class="sub-detail__btn" id="sub-detail-allergen-update-btn" style="margin:0 !important;">Update allergens</button></div><p class="sub-detail__allergen-msg" id="sub-detail-allergen-api-msg" aria-live="polite" style="display:none;margin:4px 0 0 0 !important;padding:0 !important;font-size:13px;"></p></div>';
          var mealsHtml = '';
          var selectedMealsStr = '';
          var selectedVariantsStr = '';
          if (Array.isArray(contractDetails)) {
            contractDetails.forEach(function(li) {
              var attrs = li.customAttributes || [];
              attrs.forEach(function(a) {
                if (a.key === 'Selected meals') selectedMealsStr = a.value || '';
                if (a.key === '_selected_variants') selectedVariantsStr = a.value || '';
              });
            });
          }
          if (selectedMealsStr) {
            var mealEntries = selectedMealsStr.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
            var selectedNames = [];
            var mealRows = '';

            function buildMealRow(name, qty, variantId, notInPool, allergenWarning, tags) {
              var handle = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
              var zeroClass = qty === 0 ? ' is-zero-qty' : '';
              var poolClass = notInPool ? ' is-not-in-pool' : '';
              var warnClass = allergenWarning ? ' has-allergen-warning' : '';
              var vidAttr = variantId ? ' data-variant-id="' + variantId + '"' : '';
              var tagsAttr = tags ? ' data-tags="' + tags.replace(/"/g, '&quot;') + '"' : '';
              var notInPoolTag = notInPool ? '<span class="order-detail-ufc__not-in-pool-tag">Not on this week\u2019s menu</span>' : '';
              var allergenTag = allergenWarning ? '<span class="order-detail-ufc__allergen-warn-tag">\u26a0 Contains your allergen: ' + allergenWarning + '</span>' : '';
              return '<div class="order-detail-ufc__meal-row' + zeroClass + poolClass + warnClass + '" data-handle="' + handle + '" data-meal-name="' + name.replace(/"/g, '&quot;') + '"' + vidAttr + tagsAttr + '>' +
                '<div class="order-detail-ufc__meal-img--placeholder" data-img-slot></div>' +
                '<div class="order-detail-ufc__meal-info"><p class="order-detail-ufc__meal-name">' + name.replace(/</g,'&lt;') + notInPoolTag + allergenTag + '</p>' +
                '<div class="order-detail-ufc__meal-nutrition" data-nutrition-slot></div></div>' +
                '<div class="order-detail-ufc__meal-qty"><div class="order-detail-ufc__meal-qty-view">Qty: <span class="q">' + qty + '</span></div>' +
                '<div class="order-detail-ufc__meal-qty-edit" style="display:none;"><button type="button" data-op="minus">-</button><span class="q">' + qty + '</span><button type="button" data-op="plus">+</button></div></div></div>';
            }

            var parsedVariants = {};
            try { parsedVariants = selectedVariantsStr ? JSON.parse(selectedVariantsStr) : {}; } catch(e) {}

            var colTypesEarly = {};
            try {
              var ctEl2 = document.getElementById('sub-detail-collection-types');
              if (ctEl2) colTypesEarly = JSON.parse(ctEl2.textContent);
            } catch(e) {}
            var allPoolItems = [].concat(colTypesEarly['cut']||[], colTypesEarly['maintain']||[], colTypesEarly['build']||[], colTypesEarly['mix']||[]);
            var titleToVid = {};
            allPoolItems.forEach(function(item) {
              if (typeof item === 'object' && item.t && item.v) {
                titleToVid[item.t.toLowerCase().trim()] = item.v;
              }
            });
            Object.keys(parsedVariants).forEach(function(vid) {
              var info = allPoolItems.find(function(item) { return typeof item === 'object' && item.v === vid; });
              if (info) titleToVid[info.t.toLowerCase().trim()] = vid;
            });

            var mealAgg = {};
            var mealOrder = [];
            mealEntries.forEach(function(entry) {
              var parts = entry.split(/\s*[×xX]\s*/);
              var name = (parts[0] || '').trim();
              var qty = parseInt(parts[1], 10) || 1;
              if (!name) return;
              if (mealAgg[name] == null) { mealAgg[name] = 0; mealOrder.push(name); }
              mealAgg[name] += qty;
            });
            var allPoolTitlesLower = allPoolItems.map(function(item) { return (typeof item === 'object' ? item.t : item).toLowerCase().trim(); });

            var colTypes = {};
            try {
              var ctEl = document.getElementById('sub-detail-collection-types');
              if (ctEl) colTypes = JSON.parse(ctEl.textContent);
            } catch(e) {}

            var selectedLower = selectedNames.map(function(n) { return n.toLowerCase(); });
            var detectedType = 'mix';
            ['cut', 'maintain', 'build'].forEach(function(t) {
              var items = colTypes[t] || [];
              var titles = items.map(function(item) { return (typeof item === 'string' ? item : item.t).toLowerCase(); });
              var allIn = selectedLower.every(function(sn) { return titles.indexOf(sn) >= 0; });
              if (allIn && selectedLower.length > 0) detectedType = t;
            });

            var poolItems = colTypes[detectedType] || colTypes['mix'] || [];
            var titleToAllergens = {};
            var titleToTags = {};
            allPoolItems.forEach(function(item) {
              if (typeof item === 'object' && item.t && item.allergens) {
                titleToAllergens[item.t.toLowerCase().trim()] = item.allergens.split(',').map(function(x){ return x.trim().toLowerCase(); }).filter(Boolean);
              }
              if (typeof item === 'object' && item.t && item.tags) {
                titleToTags[item.t.toLowerCase().trim()] = item.tags;
              }
            });
            var userAllergenLower = allergenSelectedList.map(function(x){ return x.toLowerCase(); });

            mealOrder.forEach(function(name) {
              selectedNames.push(name);
              var vid = titleToVid[name.toLowerCase().trim()] || '';
              var notInPool = allPoolTitlesLower.indexOf(name.toLowerCase().trim()) < 0;
              var allergenWarnText = '';
              if (userAllergenLower.length > 0) {
                var prodAllergens = titleToAllergens[name.toLowerCase().trim()] || [];
                var conflicting = prodAllergens.filter(function(pa) { return userAllergenLower.indexOf(pa) >= 0; });
                if (conflicting.length > 0) allergenWarnText = conflicting.join(', ');
              }
              var mealTags = titleToTags[name.toLowerCase().trim()] || '';
              mealRows += buildMealRow(name, mealAgg[name], vid, notInPool, allergenWarnText, mealTags);
            });
            poolItems.forEach(function(item) {
              var title = typeof item === 'string' ? item : item.t;
              var vid = typeof item === 'string' ? '' : (item.v || '');
              var itemTags = typeof item === 'object' ? (item.tags || '') : '';
              if (selectedLower.indexOf(title.toLowerCase()) < 0) {
                // 过滤掉含有用户过敏原的菜品
                if (userAllergenLower.length > 0) {
                  var prodAllergens = titleToAllergens[title.toLowerCase().trim()] || [];
                  var hasConflict = prodAllergens.some(function(pa) {
                    return userAllergenLower.indexOf(pa) >= 0;
                  });
                  if (hasConflict) return; // 跳过含过敏原的菜品
                }
                mealRows += buildMealRow(title, 0, vid, false, '', itemTags);
              }
            });

            var totalReq = mealCount || mealEntries.reduce(function(s, e) { var p = e.split(/\s*[×xX]\s*/); return s + (parseInt(p[1],10)||1); }, 0);
            var contractIdForMeals = (s.subscriptionContractId != null ? String(s.subscriptionContractId) : (s.id != null ? String(s.id) : extractId(s))) || '';
            var changeMealsBtnHtml = manageOpen ? '<div class="order-detail-ufc__meals-actions"><a href="' + editMealsUrl.replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '" class="order-detail-ufc__btn-edit">Change meals</a></div>' : '';
            mealsHtml = '<div class="sub-detail__section" id="sub-detail-meals-section" style="margin-top:32px;margin-bottom:28px;">' +
              '<div class="order-detail-ufc__meals-header"><h2 class="order-detail-ufc__meals-title">Meals</h2>' + changeMealsBtnHtml + '</div>' +
              '<div class="order-detail-ufc__editor-msg" id="subMealsMsg"></div>' +
              '<div class="sub-detail__protein-filter" id="subProteinFilter">' +
                '<span style="font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;opacity:.65;margin-right:4px;">Filter:</span>' +
                '<button type="button" class="sub-detail__protein-pill is-active" data-protein="all">All</button>' +
                '<button type="button" class="sub-detail__protein-pill" data-protein="chicken">Chicken</button>' +
'<button type="button" class="sub-detail__protein-pill" data-protein="beef">Beef</button>' +
                '<button type="button" class="sub-detail__protein-pill" data-protein="pork">Pork</button>' +
                '<button type="button" class="sub-detail__protein-pill" data-protein="fish">Fish</button>' +
                '<button type="button" class="sub-detail__protein-pill" data-protein="shrimp">Shrimp</button>' +
                '<button type="button" class="sub-detail__protein-pill" data-protein="tofu">Plant-based</button>' +
              '</div>' +
              '<div id="subMealsMeta" data-required="' + totalReq + '" data-contract-id="' + contractIdForMeals + '" data-selected-variants="' + selectedVariantsStr.replace(/"/g, '&quot;') + '"></div>' +
              '<div id="subMealsRows">' + mealRows + '</div></div>';
          }
          /* Change plan 走 /pages/edit-meals 跳转，不再渲染内嵌面板 */
          var changePlanHtml = '';
          var contractIdForApi = (s.subscriptionContractId != null ? String(s.subscriptionContractId) : (s.id != null ? String(s.id) : extractId(s))) || '';
          var statusMsgHtml = '<div id="sub-detail-api-status-msg" class="sub-detail__api-status-msg" style="display:none;margin-bottom:12px;padding:10px 14px;border-radius:6px;font-size:13px;"></div>';
          var updatedBannerHtml = '<div id="sub-detail-updated-banner" class="sub-detail__updated-banner" role="alert" aria-live="polite">SUBSCRIPTION UPDATED</div>';
          var v2MainCard = '<div class="sub-detail-v2__stack"><div class="sub-detail-v2__card">' + backLink + topRow + statsHtml + pauseInfoHtml + manageHtml + '</div><div class="sub-detail-v2__card sub-detail-v2__card--next">' + v2NextRow + '</div></div>';
          var sectionOrder = v2MainCard + changePlanHtml + paymentUpdateBtnHtml + allergenHtml + mealsHtml;
          wrap.innerHTML = '<div class="customer order customer-account-area sub-detail__content-api" data-contract-id="' + (contractIdForApi.replace(/"/g, '&quot;')) + '"><div class="order-detail-ufc-wrapper" style="width:100%;max-width:100%;text-align:left;"><div class="order-detail-ufc sub-detail-v2-root sub-detail-v2">' + updatedBannerHtml + statusMsgHtml + sectionOrder + '</div></div></div>';
          wrap.classList.remove('sub-detail__empty');
          applyRenewalDisplayPriceToDetail(wrap, contractIdForApi, s.currencyCode, mealCount, planPrice);
          bindSubActionButtons(wrap);
          checkPaymentStatus(wrap, contractIdForApi);
          bindAllergenPillsAndUpdate(wrap);
          (function forceTightAllergen(root) {
            if (!root) return;
            var sec = root.querySelector('#sub-detail-allergens-api');
            if (!sec) return;
            sec.style.setProperty('margin-top', '8px', 'important');
            sec.style.setProperty('margin-bottom', '6px', 'important');
            sec.style.setProperty('margin-left', '0', 'important');
            sec.style.setProperty('margin-right', 'auto', 'important');
            sec.style.setProperty('padding', '0', 'important');
            var h2 = sec.querySelector('h2');
            if (h2) {
              h2.style.setProperty('margin', '0 0 12px 0', 'important');
              h2.style.setProperty('padding', '0', 'important');
              h2.style.setProperty('line-height', '1.2', 'important');
              h2.style.setProperty('font-size', '18px', 'important');
            }
            var grid = sec.querySelector('.sub-detail__allergen-grid');
            if (grid) {
              grid.style.setProperty('margin', '0', 'important');
              grid.style.setProperty('padding', '0', 'important');
            }
            var actions = sec.querySelector('.sub-detail__allergen-actions');
            if (actions) {
              actions.style.setProperty('margin', '14px 0 0 0', 'important');
              actions.style.setProperty('padding', '0', 'important');
            }
            var btn = sec.querySelector('.sub-detail__btn');
            if (btn) btn.style.setProperty('margin', '0', 'important');
          })(wrap);
          loadMealImages(wrap);
          bindMealEditing(wrap);
          bindProteinFilter(wrap);
          (function bindManageTiles(root) {
            if (!root) return;
            root.querySelectorAll('[data-manage-action]').forEach(function(btn) {
              btn.addEventListener('click', function() {
                var a = btn.getAttribute('data-manage-action');
                if (a === 'allergen') {
                  var el = document.getElementById('sub-detail-allergens-api');
                  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else if (a === 'payment') {
                  var p = document.getElementById('paymentUpdateBtn');
                  if (p) p.click();
                }
              });
            });
          })(wrap);
          return true;
        }
        function bindAllergenPillsAndUpdate(wrapEl) {
          if (!wrapEl) return;
          var pills = wrapEl.querySelectorAll('#sub-detail-allergens-api .sub-detail__allergen-pill');
          var userHasInteracted = false;
          function forceApplyLabels(selectedLabels) {
            var map = {};
            (selectedLabels || []).forEach(function(v) { map[String(v || '').trim().toLowerCase()] = true; });
            pills.forEach(function(p) {
              var label = (p.getAttribute('data-allergen') || '').trim().toLowerCase();
              var isOn = !!map[label];
              p.classList.toggle('is-selected', isOn);
              p.setAttribute('aria-pressed', isOn ? 'true' : 'false');
              p.style.color = isOn ? '#dc2626' : '#374151';
              p.style.borderColor = isOn ? '#dc2626' : '#e5e7eb';
              p.style.borderWidth = isOn ? '2px' : '1px';
              p.style.background = isOn ? '#fef2f2' : '#fff';
            });
          }
          function applySelectedLabels(selectedLabels) {
            if (userHasInteracted) return;
            forceApplyLabels(selectedLabels);
          }
          pills.forEach(function(pill) {
            pill.addEventListener('click', function() {
              userHasInteracted = true;
              this.classList.toggle('is-selected');
              var sel = this.classList.contains('is-selected');
              this.setAttribute('aria-pressed', sel ? 'true' : 'false');
              this.style.color = sel ? '#dc2626' : '#374151';
              this.style.borderColor = sel ? '#dc2626' : '#e5e7eb';
              this.style.borderWidth = sel ? '2px' : '1px';
              this.style.background = sel ? '#fef2f2' : '#fff';
            });
          });
          var updateBtn = wrapEl.querySelector('#sub-detail-allergen-update-btn');
          var msgEl = wrapEl.querySelector('#sub-detail-allergen-api-msg');
          if (!updateBtn) return;
          function showAllergenMsg(text, isError) {
            if (!msgEl) return;
            msgEl.textContent = text;
            msgEl.style.display = 'block';
            msgEl.style.color = isError ? '#dc2626' : '#166534';
          }
          function getSelectedAllergens() {
            var selected = [];
            pills.forEach(function(p) { if (p.classList.contains('is-selected')) selected.push(p.getAttribute('data-allergen')); });
            return selected;
          }
          function readAllergensFromDirectApi(contractId, done) {
            if (!contractId) { done([]); return; }
            var endpoints = [
              '/apps/ufc-ignite/subscription-allergens?contractId=' + encodeURIComponent(contractId),
              '/apps/ufc-ignite/signup-and-invite/subscription-allergens?contractId=' + encodeURIComponent(contractId)
            ];
            (async function() {
              for (var i = 0; i < endpoints.length; i++) {
                try {
                  var r = await (window.ufcFetchWithTimeout || fetch)(endpoints[i], { method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, 20000);
                  var json = await r.json();
                  if (r.ok && json && json.ok) { done(json.allergens || []); return; }
                  if (r.status === 404) continue;
                } catch(e) {}
              }
              done([]);
            })();
          }
          function extractLineIdsFromRaw(raw) {
            var contract = raw && (raw.subscriptionContract || (raw.data && raw.data.subscriptionContract) || raw);
            var lines = contract && contract.lines ? contract.lines : [];
            var nodes = lines.nodes || (lines.edges && lines.edges.map(function(e){ return e && e.node; })) || (Array.isArray(lines) ? lines : []);
            var ids = [];
            (Array.isArray(nodes) ? nodes : []).forEach(function(n) {
              var id = n && (n.id || (n.node && n.node.id));
              if (id && (String(id).indexOf('SubscriptionLine') >= 0 || String(id).indexOf('SubscriptionLineItem') >= 0)) ids.push(id);
            });
            return ids;
          }
          function updateViaDirectApi(contractId, selected, done) {
            if (!contractId) { done(new Error('Missing contract ID.')); return; }
            var endpoints = [
              '/apps/ufc-ignite/update-subscription-allergens',
              '/apps/ufc-ignite/signup-and-invite/update-subscription-allergens'
            ];
            var payload = JSON.stringify({ contractId: contractId, allergens: selected });
            (async function() {
              var lastErr = null;
              for (var i = 0; i < endpoints.length; i++) {
                try {
                  var r = await (window.ufcFetchWithTimeout || fetch)(endpoints[i], {
                    method: 'POST', credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: payload
                  }, 20000);
                  var json = {};
                  try { json = await r.json(); } catch(e) {}
                  if (r.ok && json && json.ok) { done(null); return; }
                  if (r.status === 404) { lastErr = new Error('Endpoint not found'); continue; }
                  throw new Error(json.error || json.message || ('HTTP ' + r.status));
                } catch(e) { lastErr = e; }
              }
              done(lastErr || new Error('All endpoints failed'));
            })();
          }
          updateBtn.addEventListener('click', function() {
            var selected = getSelectedAllergens();
            var contractEl = wrapEl.querySelector('[data-contract-id]');
            var contractId = contractEl ? contractEl.getAttribute('data-contract-id') : '';
            if (!contractId) {
              showAllergenMsg('Could not find subscription contract.', true);
              return;
            }
            if (msgEl) msgEl.style.display = 'none';
            updateBtn.disabled = true;
            var onSuccess = function() {
              try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
              var banner = wrapEl.querySelector('#sub-detail-updated-banner');
              if (banner) { banner.classList.add('is-visible'); banner.textContent = 'ALLERGENS UPDATED'; }
              userHasInteracted = false;
              forceApplyLabels(selected);
              showAllergenMsg('', false);
              updateBtn.disabled = false;
              setTimeout(function() { if (banner) banner.classList.remove('is-visible'); }, 3000);
            };
            var onError = function(err) {
              updateBtn.disabled = false;
              showAllergenMsg('Update failed: ' + ((err && err.message) || 'Please try again.'), true);
            };
            // 业务要求：前台更新必须全量同步所有 line，因此直接走 Direct API。
            updateViaDirectApi(contractId, selected, function(err) {
              if (err) onError(err);
              else onSuccess();
            });
          });
          wrapEl._refreshAllergens = function() {
            var contractEl = wrapEl.querySelector('[data-contract-id]');
            var cid = contractEl ? contractEl.getAttribute('data-contract-id') : '';
            if (!cid) return;
            userHasInteracted = false;
            readAllergensFromDirectApi(cid, function(arr) {
              if (arr && arr.length > 0) forceApplyLabels(arr);
            });
          };
          (function initPillsFromApi() {
            var contractEl = wrapEl.querySelector('[data-contract-id]');
            var contractId = contractEl ? contractEl.getAttribute('data-contract-id') : '';
            if (!contractId) return;
            readAllergensFromDirectApi(contractId, function(arr) {
              if (arr && arr.length > 0) applySelectedLabels(arr);
            });
          })();
        }
        function mapActionToStatus(action) {
          if (action === 'resume') return 'ACTIVE';
          if (action === 'pause') return 'PAUSED';
          if (action === 'cancel') return 'CANCELLED';
          return '';
        }
        function loadMealImages(container) {
          var nutritionMap = {};
          try {
            var mapEl = document.getElementById('sub-detail-nutrition-map');
            if (mapEl) nutritionMap = JSON.parse(mapEl.textContent);
          } catch(e) {}

          var rows = container.querySelectorAll('#subMealsRows .order-detail-ufc__meal-row');
          rows.forEach(function(row) {
            var mealName = row.getAttribute('data-meal-name') || '';
            if (!mealName) return;

            var cached = nutritionMap[mealName];
            if (cached) {
              if (cached.img) {
                var imgSlot = row.querySelector('[data-img-slot]');
                if (imgSlot) {
                  var img = document.createElement('img');
                  img.className = 'order-detail-ufc__meal-img';
                  img.src = cached.img;
                  img.alt = mealName;
                  img.width = 72; img.height = 72; img.loading = 'lazy';
                  imgSlot.replaceWith(img);
                }
              }
              var nutSlot = row.querySelector('[data-nutrition-slot]');
              if (nutSlot && (cached.cal || cached.carbs || cached.fat || cached.protein)) {
                var cal = cached.cal || '—';
                var carbs = cached.carbs || '';
                var fat = cached.fat || '';
                var protein = cached.protein || '';
                nutSlot.innerHTML =
                  '<span class="n-stat"><span class="n-label">Cal:</span><span class="n-value">' + cal + '</span></span>' +
                  '<span class="n-stat"><span class="n-label">Carbs:</span><span class="n-value">' + (carbs ? carbs + 'g' : '—') + '</span></span>' +
                  '<span class="n-stat"><span class="n-label">Fat:</span><span class="n-value">' + (fat ? fat + 'g' : '—') + '</span></span>' +
                  '<span class="n-stat"><span class="n-label">Protein:</span><span class="n-value">' + (protein ? protein + 'g' : '—') + '</span></span>';
              }
              return;
            }

            var searchUrl = '/search/suggest.json?q=' + encodeURIComponent(mealName) + '&resources[type]=product&resources[limit]=3';
            (window.ufcFetchWithTimeout || fetch)(searchUrl, { credentials: 'same-origin' }, 12000)
              .then(function(r) { return r.ok ? r.json() : null; })
              .then(function(data) {
                var products = data && data.resources && data.resources.results && data.resources.results.products || [];
                var match = products.find(function(p) { return p.title.toLowerCase() === mealName.toLowerCase(); }) || products[0];
                if (!match) return;
                var imgSlot = row.querySelector('[data-img-slot]');
                if (imgSlot && match.image) {
                  var img = document.createElement('img');
                  img.className = 'order-detail-ufc__meal-img';
                  img.src = match.image.replace(/(\.\w+)(\?|$)/, '_144x144$1$2');
                  img.alt = match.title;
                  img.width = 72; img.height = 72; img.loading = 'lazy';
                  imgSlot.replaceWith(img);
                }
              }).catch(function() {});
          });
        }
        function bindProteinFilter(container) {
          var filterWrap = container.querySelector('#subProteinFilter');
          if (!filterWrap) return;
          var pills = filterWrap.querySelectorAll('.sub-detail__protein-pill');
          var mealsRows = container.querySelector('#subMealsRows');
          if (!mealsRows) return;

          /* 蛋白质关键词映射：pill data-protein 值 -> 产品 tags 中可能出现的关键词（小写） */
          var proteinKeywords = {
            'chicken': ['chicken'],
'beef': ['beef', 'steak'],
            'pork': ['pork'],
            'fish': ['fish', 'salmon', 'tilapia', 'cod', 'tuna'],
            'shrimp': ['shrimp', 'prawn'],
            'tofu': ['tofu', 'plant-based', 'plant based', 'vegan', 'vegetarian']
          };

          function applyFilter(selected) {
            var rows = mealsRows.querySelectorAll('.order-detail-ufc__meal-row');
            rows.forEach(function(row) {
              if (selected === 'all') {
                row.classList.remove('is-hidden-protein');
                return;
              }
              var tags = (row.getAttribute('data-tags') || '').toLowerCase();
              var name = (row.getAttribute('data-meal-name') || '').toLowerCase();
              var keywords = proteinKeywords[selected] || [selected];
              var match = keywords.some(function(kw) {
                return tags.indexOf(kw) >= 0 || name.indexOf(kw) >= 0;
              });
              row.classList.toggle('is-hidden-protein', !match);
            });
          }

          pills.forEach(function(pill) {
            pill.addEventListener('click', function() {
              pills.forEach(function(p) { p.classList.remove('is-active'); });
              pill.classList.add('is-active');
              applyFilter(pill.getAttribute('data-protein'));
            });
          });
        }
        function bindChangePlan(container) {
          var openBtn = container.querySelector('#cpOpenBtn');
          var panel = container.querySelector('#cpPanel');
          var cancelBtn = container.querySelector('#cpCancel');
          var submitBtn = container.querySelector('#cpSubmit');
          var msgEl = container.querySelector('#cpMsg');
          var countEl = container.querySelector('#cpCount');
          var requiredEl = container.querySelector('#cpRequired');
          var goalBtns = container.querySelectorAll('[data-cp-goal]');
          var mealPills = container.querySelectorAll('[data-cp-meals]');
          var mealGrid = container.querySelector('#cpMealGrid');
          var proteinPills = container.querySelectorAll('[data-cp-protein]');
          if (!panel || !mealGrid) return;

          var colTypes = {};
          try {
            var ctEl = document.getElementById('sub-detail-collection-types');
            if (ctEl) colTypes = JSON.parse(ctEl.textContent);
          } catch(e) {}
          var nutritionMap = {};
          try {
            var nmEl = document.getElementById('sub-detail-nutrition-map');
            if (nmEl) nutritionMap = JSON.parse(nmEl.textContent);
          } catch(e) {}

          var cpState = { goal: '', meals: 4, counts: {}, proteinFilter: 'all' };

          /* 从当前 plan 推断初始 goal */
          goalBtns.forEach(function(btn) { if (btn.classList.contains('is-active')) cpState.goal = btn.getAttribute('data-cp-goal'); });
          mealPills.forEach(function(btn) { if (btn.classList.contains('is-active')) cpState.meals = parseInt(btn.getAttribute('data-cp-meals'), 10) || 4; });

          /* 获取用户过敏原 */
          function getUserAllergens() {
            var pills = container.querySelectorAll('#sub-detail-allergens-api .sub-detail__allergen-pill.is-selected');
            var list = [];
            pills.forEach(function(p) { list.push((p.getAttribute('data-allergen') || '').toLowerCase()); });
            return list;
          }

          var proteinKeywords = {
            'chicken': ['chicken'],
            'beef': ['beef', 'steak'],
            'pork': ['pork'],
            'fish': ['fish', 'salmon', 'tilapia', 'cod', 'tuna'],
            'shrimp': ['shrimp', 'prawn'],
            'tofu': ['tofu', 'plant-based', 'plant based', 'vegan', 'vegetarian']
          };

          function renderMealGrid() {
            if (!cpState.goal) { mealGrid.innerHTML = '<p style="color:#6b7280;font-size:13px;">Please select a goal first.</p>'; return; }
            var goalKey = cpState.goal === 'mix' ? 'mix' : cpState.goal;
            var pool;
            if (goalKey === 'mix') {
              pool = [];
              var seen = {};
              ['cut', 'maintain', 'build', 'mix'].forEach(function(k) {
                (colTypes[k] || []).forEach(function(item) {
                  var t = (typeof item === 'object' ? item.t : item).toLowerCase();
                  if (!seen[t]) { seen[t] = true; pool.push(item); }
                });
              });
            } else {
              pool = colTypes[goalKey] || [];
            }
            var userAllergens = getUserAllergens();
            var html = '';
            pool.forEach(function(item) {
              var title = typeof item === 'object' ? item.t : item;
              var vid = typeof item === 'object' ? (item.v || '') : '';
              var tags = typeof item === 'object' ? (item.tags || '') : '';
              var allergens = typeof item === 'object' ? (item.allergens || '') : '';
              /* 过滤过敏原 */
              if (userAllergens.length > 0 && allergens) {
                var prodAllergens = allergens.split(',').map(function(x) { return x.trim().toLowerCase(); });
                var hasConflict = prodAllergens.some(function(pa) { return userAllergens.indexOf(pa) >= 0; });
                if (hasConflict) return;
              }
              var qty = cpState.counts[vid] || 0;
              var nut = nutritionMap[title] || {};
              var imgSrc = nut.img || '';
              var metaParts = [];
              if (nut.cal) metaParts.push(nut.cal + ' cal');
              if (nut.protein) metaParts.push(nut.protein + 'g protein');
              html += '<div class="cp-meal-card' + (qty > 0 ? ' has-qty' : '') + '" data-cp-vid="' + vid + '" data-cp-title="' + title.replace(/"/g, '&quot;') + '" data-cp-tags="' + tags.replace(/"/g, '&quot;') + '">' +
                (imgSrc ? '<img class="cp-meal-card__img" src="' + imgSrc + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy">' : '<div class="cp-meal-card__img"></div>') +
                '<div class="cp-meal-card__info"><p class="cp-meal-card__name">' + title.replace(/</g, '&lt;') + '</p>' +
                '<div class="cp-meal-card__meta">' + metaParts.join(' · ') + '</div></div>' +
                '<div class="cp-meal-card__qty"><button type="button" data-cp-op="minus">-</button><span class="q">' + qty + '</span><button type="button" data-cp-op="plus">+</button></div></div>';
            });
            if (!html) html = '<p style="color:#6b7280;font-size:13px;">No meals available for this goal.</p>';
            mealGrid.innerHTML = html;
            applyProteinFilter();
          }

          function applyProteinFilter() {
            var filter = cpState.proteinFilter;
            var cards = mealGrid.querySelectorAll('.cp-meal-card');
            cards.forEach(function(card) {
              if (filter === 'all') { card.classList.remove('is-hidden'); return; }
              var tags = (card.getAttribute('data-cp-tags') || '').toLowerCase();
              var name = (card.getAttribute('data-cp-title') || '').toLowerCase();
              var keywords = proteinKeywords[filter] || [filter];
              var match = keywords.some(function(kw) { return tags.indexOf(kw) >= 0 || name.indexOf(kw) >= 0; });
              card.classList.toggle('is-hidden', !match);
            });
          }

          function updateCounter() {
            var total = 0;
            Object.keys(cpState.counts).forEach(function(k) { total += cpState.counts[k]; });
            if (countEl) {
              countEl.textContent = total;
              countEl.className = 'count' + (total === cpState.meals ? ' is-full' : (total > cpState.meals ? ' is-over' : ''));
            }
            if (requiredEl) requiredEl.textContent = cpState.meals;
            if (submitBtn) submitBtn.disabled = (total !== cpState.meals);
          }

          function showMsg(text, isError) {
            if (!msgEl) return;
            msgEl.textContent = text;
            msgEl.style.color = isError ? '#dc2626' : '#16a34a';
            msgEl.style.display = text ? 'block' : 'none';
          }

          if (openBtn) {
            openBtn.addEventListener('click', function() {
              panel.classList.add('is-open');
              openBtn.style.display = 'none';
              cpState.counts = {};
              renderMealGrid();
              updateCounter();
              showMsg('', false);
            });
          }

          if (cancelBtn) {
            cancelBtn.addEventListener('click', function() {
              panel.classList.remove('is-open');
              if (openBtn) openBtn.style.display = '';
              cpState.counts = {};
              showMsg('', false);
            });
          }

          /* Goal selection */
          goalBtns.forEach(function(btn) {
            btn.addEventListener('click', function() {
              goalBtns.forEach(function(b) { b.classList.remove('is-active'); });
              btn.classList.add('is-active');
              cpState.goal = btn.getAttribute('data-cp-goal');
              cpState.counts = {};
              renderMealGrid();
              updateCounter();
            });
          });

          /* Meals per week selection */
          mealPills.forEach(function(pill) {
            pill.addEventListener('click', function() {
              mealPills.forEach(function(p) { p.classList.remove('is-active'); });
              pill.classList.add('is-active');
              cpState.meals = parseInt(pill.getAttribute('data-cp-meals'), 10) || 4;
              /* 截断已选数量 */
              var total = 0;
              Object.keys(cpState.counts).forEach(function(k) { total += cpState.counts[k]; });
              if (total > cpState.meals) {
                var keys = Object.keys(cpState.counts);
                var remaining = cpState.meals;
                var next = {};
                for (var i = 0; i < keys.length; i++) {
                  var k = keys[i];
                  var qty = cpState.counts[k];
                  if (remaining <= 0) break;
                  if (qty <= remaining) { next[k] = qty; remaining -= qty; }
                  else { next[k] = remaining; remaining = 0; }
                }
                cpState.counts = next;
                /* 更新 grid 中的数量显示 */
                mealGrid.querySelectorAll('.cp-meal-card').forEach(function(card) {
                  var vid = card.getAttribute('data-cp-vid');
                  var q = cpState.counts[vid] || 0;
                  card.querySelector('.q').textContent = q;
                  card.classList.toggle('has-qty', q > 0);
                });
              }
              updateCounter();
            });
          });

          /* Protein filter */
          proteinPills.forEach(function(pill) {
            pill.addEventListener('click', function() {
              proteinPills.forEach(function(p) { p.classList.remove('is-active'); });
              pill.classList.add('is-active');
              cpState.proteinFilter = pill.getAttribute('data-cp-protein');
              applyProteinFilter();
            });
          });

          /* Meal qty +/- */
          mealGrid.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-cp-op]');
            if (!btn) return;
            var card = btn.closest('.cp-meal-card');
            if (!card) return;
            var vid = card.getAttribute('data-cp-vid');
            if (!vid) return;
            var op = btn.getAttribute('data-cp-op');
            var current = cpState.counts[vid] || 0;
            var total = 0;
            Object.keys(cpState.counts).forEach(function(k) { total += cpState.counts[k]; });
            if (op === 'plus') {
              if (total >= cpState.meals) return;
              cpState.counts[vid] = current + 1;
            } else {
              if (current <= 0) return;
              cpState.counts[vid] = current - 1;
              if (cpState.counts[vid] <= 0) delete cpState.counts[vid];
            }
            card.querySelector('.q').textContent = cpState.counts[vid] || 0;
            card.classList.toggle('has-qty', (cpState.counts[vid] || 0) > 0);
            updateCounter();
          });

          /* Submit */
          if (submitBtn) submitBtn.addEventListener('click', function() {
            var total = 0;
            Object.keys(cpState.counts).forEach(function(k) { total += cpState.counts[k]; });
            if (total !== cpState.meals) {
              showMsg('Please select exactly ' + cpState.meals + ' meals.', true);
              return;
            }
            if (!cpState.goal) {
              showMsg('Please select a goal.', true);
              return;
            }
            var contractEl = container.querySelector('[data-contract-id]');
            var contractId = contractEl ? contractEl.getAttribute('data-contract-id') : '';
            if (!contractId) {
              showMsg('Missing subscription info.', true);
              return;
            }
            /* 构建 selectionText */
            var selParts = [];
            mealGrid.querySelectorAll('.cp-meal-card').forEach(function(card) {
              var vid = card.getAttribute('data-cp-vid');
              var qty = cpState.counts[vid] || 0;
              if (qty > 0) {
                var name = card.getAttribute('data-cp-title') || '';
                selParts.push(name + ' \u00d7 ' + qty);
              }
            });
            var selectionText = selParts.join(', ');
            submitBtn.disabled = true;
            showMsg('Updating plan...', false);
            if (msgEl) msgEl.style.color = '#666';
            var payload = JSON.stringify({
              contractId: contractId,
              goal: cpState.goal,
              mealsPerWeek: cpState.meals,
              selectedVariants: cpState.counts,
              selectionText: selectionText,
              sourceAction: 'direct'
            });
            fetchJsonWithPathFallback([
              '/apps/ufc-ignite/change-subscription-plan',
              '/apps/ufc-ignite/signup-and-invite/change-subscription-plan',
            ], {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: payload
            }, 120000)
            .then(function(result) {
              if (result.ok && result.data.ok) {
                showMsg('Plan updated successfully! Reloading...', false);
                try { sessionStorage.removeItem('ufc_subs_cache'); } catch(e) {}
                var banner = container.querySelector('#sub-detail-updated-banner');
                if (banner) { banner.textContent = 'PLAN UPDATED'; banner.classList.add('is-visible'); }
                setTimeout(function() { window.location.reload(); }, 1500);
              } else if (result.data && result.data.error === 'cutoff_passed') {
                showMsg(result.data.message || 'This delivery is past its weekly cutoff and can no longer be changed. Changes apply from your next delivery.', true);
                submitBtn.disabled = false;
              } else {
                showMsg('Update failed: ' + (result.data.message || result.data.error || 'Please try again.'), true);
                submitBtn.disabled = false;
              }
            })
            .catch(function(err) {
              showMsg('Update failed: ' + (err.message || 'Please try again.'), true);
              submitBtn.disabled = false;
            });
          });

          /* 由「Change plan setting」磁贴打开面板时无 #cpOpenBtn，需初始化餐格 */
          container._ufcRefreshCpGrid = function() {
            renderMealGrid();
            updateCounter();
          };
        }
        function bindMealEditing(container) {
          var editBtn = container.querySelector('#subMealsEditToggle');
          var saveBtn = container.querySelector('#subMealsSave');
          var cancelBtn = container.querySelector('#subMealsCancel');
          var metaEl = container.querySelector('#subMealsMeta');
          var msgEl = container.querySelector('#subMealsMsg');
          var selectedEl = container.querySelector('#subMealsSelected');
          if (!editBtn || !saveBtn || !cancelBtn || !metaEl) return;
          var required = parseInt(metaEl.getAttribute('data-required') || '0', 10);
          var contractId = metaEl.getAttribute('data-contract-id') || '';
          var apiKey = (container.closest('[data-api-key]') || container.querySelector('[data-api-key]') || {getAttribute:function(){return '';}}).getAttribute('data-api-key') || '';
          if (!apiKey) { var wrapOuter = document.getElementById('sub-detail-load-by-id'); if (wrapOuter) apiKey = wrapOuter.getAttribute('data-api-key') || ''; }
          var rows = container.querySelectorAll('#subMealsRows .order-detail-ufc__meal-row');
          var origQtys = [];
          rows.forEach(function(r) { origQtys.push(parseInt(r.querySelector('.order-detail-ufc__meal-qty-view .q').textContent, 10) || 0); });

          function updateCount() {
            var total = 0;
            rows.forEach(function(r) { total += parseInt(r.querySelector('.order-detail-ufc__meal-qty-edit .q').textContent, 10) || 0; });
            if (selectedEl) selectedEl.textContent = total;
          }
          var mealsSection = container.querySelector('#sub-detail-meals-section');
          editBtn.addEventListener('click', function() {
            if (mealsSection) mealsSection.classList.add('is-editing');
            editBtn.style.display = 'none'; saveBtn.style.display = ''; cancelBtn.style.display = '';
            rows.forEach(function(r) { r.querySelector('.order-detail-ufc__meal-qty-view').style.display = 'none'; r.querySelector('.order-detail-ufc__meal-qty-edit').style.display = ''; });
          });
          cancelBtn.addEventListener('click', function() {
            if (mealsSection) mealsSection.classList.remove('is-editing');
            editBtn.style.display = ''; saveBtn.style.display = 'none'; cancelBtn.style.display = 'none';
            rows.forEach(function(r, i) {
              r.querySelector('.order-detail-ufc__meal-qty-view').style.display = '';
              r.querySelector('.order-detail-ufc__meal-qty-edit').style.display = 'none';
              r.querySelector('.order-detail-ufc__meal-qty-edit .q').textContent = origQtys[i];
              r.querySelector('.order-detail-ufc__meal-qty-view .q').textContent = origQtys[i];
            });
            updateCount();
            if (msgEl) { msgEl.textContent = ''; msgEl.style.display = 'none'; }
          });
          rows.forEach(function(r) {
            r.querySelectorAll('[data-op]').forEach(function(btn) {
              btn.addEventListener('click', function() {
                var qEl = r.querySelector('.order-detail-ufc__meal-qty-edit .q');
                var v = parseInt(qEl.textContent, 10) || 0;
                if (btn.getAttribute('data-op') === 'plus') v++;
                else if (v > 0) v--;
                qEl.textContent = v;
                updateCount();
              });
            });
          });
          saveBtn.addEventListener('click', function() {
            var total = 0;
            var mealParts = [];
            var newVariantMap = {};
            var missingVid = [];
            rows.forEach(function(r) {
              var qty = parseInt(r.querySelector('.order-detail-ufc__meal-qty-edit .q').textContent, 10) || 0;
              total += qty;
              if (qty > 0) {
                var name = r.getAttribute('data-meal-name');
                var vid = r.getAttribute('data-variant-id') || '';
                mealParts.push(name + ' × ' + qty);
                if (vid) {
                  newVariantMap[vid] = (newVariantMap[vid] || 0) + qty;
                } else {
                  missingVid.push(name);
                }
              }
            });
            if (total !== required) {
              if (msgEl) { msgEl.textContent = 'Please select exactly ' + required + ' meals (currently ' + total + ').'; msgEl.style.display = 'block'; msgEl.style.color = '#dc2626'; }
              return;
            }
            if (missingVid.length) {
              if (msgEl) { msgEl.textContent = 'Unable to resolve variant for: ' + missingVid.join(', ') + '. Please update the meals below to this week\u2019s available menu, or contact support.'; msgEl.style.display = 'block'; msgEl.style.color = '#dc2626'; }
              return;
            }
            if (!contractId) {
              if (msgEl) { msgEl.textContent = 'Missing subscription info.'; msgEl.style.display = 'block'; msgEl.style.color = '#dc2626'; }
              return;
            }
            saveBtn.disabled = true;
            if (msgEl) { msgEl.textContent = 'Saving...'; msgEl.style.display = 'block'; msgEl.style.color = '#666'; }
            var newMealsStr = mealParts.join(', ');

            (async function() {
              var proxyEndpoints = [
                '/apps/ufc-ignite/update-subscription-meals',
                '/apps/ufc-ignite/signup-and-invite/update-subscription-meals'
              ];
              var payload = JSON.stringify({
                contractId: contractId,
                customerEmail: ufcSubDetailCustomerEmail(),
                selectedVariants: newVariantMap,
                selectionText: newMealsStr,
                sourceAction: 'direct'
              });

              return (async function() {
                var lastErr = null;
                for (var i = 0; i < proxyEndpoints.length; i++) {
                  try {
                    var resp = await (window.ufcFetchWithTimeout || fetch)(proxyEndpoints[i], {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: payload
                    }, 90000);
                    var text = await resp.text();
                    var json = {};
                    try { json = text ? JSON.parse(text) : {}; } catch(e) {}
                    if (resp.ok && json && json.ok) return json;
                    if (json && json.error === 'cutoff_passed') return { __cutoff: true, message: json.message };
                    if (resp.status === 404) { lastErr = new Error('Endpoint not found'); continue; }
                    throw new Error(json.message || json.error || ('HTTP ' + resp.status));
                  } catch(e) { lastErr = e; }
                }
                throw lastErr || new Error('All endpoints failed');
              })();
            })()
              .then(function(result) {
                if (result && result.__cutoff) {
                  if (msgEl) { msgEl.textContent = result.message || 'This delivery is past its weekly cutoff and can no longer be changed. Changes apply from your next delivery.'; msgEl.style.color = '#dc2626'; msgEl.style.fontSize = ''; msgEl.style.fontWeight = ''; }
                  saveBtn.disabled = false;
                  return;
                }
                if (msgEl) { msgEl.textContent = 'Meals updated!'; msgEl.style.color = '#16a34a'; msgEl.style.fontSize = '18px'; msgEl.style.fontWeight = '700'; }
                rows.forEach(function(r, i) {
                  var newQ = parseInt(r.querySelector('.order-detail-ufc__meal-qty-edit .q').textContent, 10) || 0;
                  origQtys[i] = newQ;
                  r.querySelector('.order-detail-ufc__meal-qty-view .q').textContent = newQ;
                  r.classList.toggle('is-zero-qty', newQ <= 0);
                });
                if (mealsSection) mealsSection.classList.remove('is-editing');
                editBtn.style.display = ''; saveBtn.style.display = 'none'; cancelBtn.style.display = 'none';
                rows.forEach(function(r) { r.querySelector('.order-detail-ufc__meal-qty-view').style.display = ''; r.querySelector('.order-detail-ufc__meal-qty-edit').style.display = 'none'; });
                saveBtn.disabled = false;
                try { sessionStorage.removeItem('ufc_subs_cache'); } catch(e) {}
                if (container && container.closest && container.closest('[data-wrap]') && container.closest('[data-wrap]')._refreshAllergens) {
                  container.closest('[data-wrap]')._refreshAllergens();
                } else {
                  var w = container; while (w && !w._refreshAllergens) w = w.parentElement;
                  if (w && w._refreshAllergens) w._refreshAllergens();
                }
              })
              .catch(function(e) {
                if (msgEl) { msgEl.textContent = 'Failed to save: ' + e.message; msgEl.style.color = '#dc2626'; }
                saveBtn.disabled = false;
              });
          });
        }
        function checkPaymentStatus(container, contractId) {
          if (!container || !contractId) return;
          fetchJsonWithFallback('/apps/ufc-ignite/contract-payment-status?contractId=' + encodeURIComponent(contractId), {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          }, 15000)
          .then(function(result) {
            var d = result.data || {};
            if (d.ok && d.lastPaymentStatus === 'FAILED' && d.status === 'ACTIVE') {
              var banner = document.createElement('div');
              banner.id = 'paymentFailedBanner';
              banner.setAttribute('role', 'alert');
              banner.style.cssText = 'background:#fef2f2;border:1px solid #fca5a5;border-radius:8px;padding:16px 20px;margin-bottom:20px;';
              banner.innerHTML = '<div style="display:flex;align-items:flex-start;gap:12px;">' +
                '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="flex-shrink:0;margin-top:2px;"><circle cx="12" cy="12" r="10" stroke="#dc2626" stroke-width="2"/><path d="M12 8v4m0 4h.01" stroke="#dc2626" stroke-width="2" stroke-linecap="round"/></svg>' +
                '<div><p style="margin:0 0 6px;font-weight:700;font-size:14px;color:#991b1b;">Payment Failed</p>' +
                '<p style="margin:0 0 12px;font-size:13px;color:#7f1d1d;line-height:1.5;">Your last payment was unsuccessful. Please update your payment method to continue receiving your meals.</p>' +
                '<button type="button" id="paymentFailedUpdateBtn" style="cursor:pointer;background:#dc2626;color:#fff;border:none;padding:3px 7px;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.02em;border-radius:6px;font-family:inherit;">UPDATE PAYMENT METHOD</button>' +
                '<div id="paymentFailedMsg" style="display:none;margin-top:8px;padding:8px 12px;border-radius:6px;font-size:13px;"></div></div></div>';
              var msgEl = container.querySelector('#sub-detail-api-status-msg');
              if (msgEl) { msgEl.parentNode.insertBefore(banner, msgEl.nextSibling); }
              else { container.querySelector('.order-detail-ufc').prepend(banner); }
              var failBtn = document.getElementById('paymentFailedUpdateBtn');
              if (failBtn) {
                failBtn.addEventListener('click', function() {
                  var root = document.getElementById('sub-detail-load-by-id');
                  var shopOrigin = (root && root.getAttribute('data-shop-origin')) || window.location.origin;
                  shopOrigin = String(shopOrigin).replace(/\/$/, '');
                  var custEmail = (root && root.getAttribute('data-customer-email')) || '';
                  var portalUrl = (root && root.getAttribute('data-payment-update-url')) || '';
                  if (portalUrl && (portalUrl.indexOf('http') === 0 || portalUrl.indexOf('//') === 0)) {
                    window.open(portalUrl, '_blank', 'noopener');
                    return;
                  }
                  var qs = 'contractId=' + encodeURIComponent(contractId);
                  if (custEmail) qs += '&email=' + encodeURIComponent(custEmail);
                  window.location.href = shopOrigin + '/apps/ufc-ignite/begin-payment-update?' + qs;
                });
              }
            }
          })
          .catch(function() {});
        }
        function bindSubActionButtons(container) {
          if (!container) return;
          function applyStatusToUi(nextStatus) {
            var s = String(nextStatus || '').toUpperCase();
            var badge = container.querySelector('.order-detail-ufc__status-badge');
            if (badge) {
              badge.textContent = s === 'ACTIVE' ? 'Active' : (s === 'PAUSED' ? 'Paused' : (s === 'CANCELLED' ? 'Cancelled' : s));
              badge.classList.toggle('order-detail-ufc__status-badge--active', s === 'ACTIVE');
              badge.classList.toggle('order-detail-ufc__status-badge--paused', s === 'PAUSED');
            }
            var topRow = container.querySelector('.order-detail-ufc__top-row');
            if (!topRow) return;
            var actionsWrap = topRow.querySelector('.order-detail-ufc__sub-actions');
            if (s === 'CANCELLED') {
              /* Cancelled 状态：仅显示 RESUME（可恢复） */
              if (!actionsWrap) {
                topRow.insertAdjacentHTML('beforeend', '<div class="order-detail-ufc__sub-actions"><button type="button" class="order-detail-ufc__sub-btn" data-sub-action="resume">RESUME</button></div>');
              } else {
                actionsWrap.innerHTML = '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="resume">RESUME</button>';
              }
              return;
            }
            /* ACTIVE：PAUSE + CANCEL（与设计稿一致）；PAUSED：RESUME [+ EXTEND] + CANCEL */
            var showResume = (s === 'PAUSED');
            if (!actionsWrap) {
              var resumeHtml = showResume ? '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="resume">RESUME</button>' : '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="pause">PAUSE</button>';
              topRow.insertAdjacentHTML('beforeend', '<div class="order-detail-ufc__sub-actions">' + resumeHtml + '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="cancel">CANCEL</button></div>');
              return;
            }
            var toggleBtn = actionsWrap.querySelector('[data-sub-action="resume"], [data-sub-action="pause"]');
            if (showResume) {
              if (toggleBtn) {
                toggleBtn.setAttribute('data-sub-action', 'resume');
                toggleBtn.textContent = 'RESUME';
                toggleBtn.disabled = false;
              } else {
                actionsWrap.insertAdjacentHTML('afterbegin', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="resume">RESUME</button>');
              }
            } else {
              if (toggleBtn) {
                toggleBtn.setAttribute('data-sub-action', 'pause');
                toggleBtn.textContent = 'PAUSE';
                toggleBtn.disabled = false;
              } else {
                actionsWrap.insertAdjacentHTML('afterbegin', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="pause">PAUSE</button>');
              }
            }
            /* Extend Pause 按钮：仅 PAUSED 状态显示 */
            var extendBtn = actionsWrap.querySelector('[data-sub-action="extend-pause"]');
            if (s === 'PAUSED') {
              if (!extendBtn) {
                var cancelBtnRef = actionsWrap.querySelector('[data-sub-action="cancel"]');
                if (cancelBtnRef) {
                  cancelBtnRef.insertAdjacentHTML('beforebegin', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="extend-pause">EXTEND PAUSE</button>');
                } else {
                  actionsWrap.insertAdjacentHTML('beforeend', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="extend-pause">EXTEND PAUSE</button>');
                }
              }
            } else {
              if (extendBtn) extendBtn.remove();
              /* 移除 pause info banner */
              var pib = container.querySelector('.pause-info-banner');
              if (pib) pib.remove();
              var pil = container.querySelector('.pause-info-line');
              if (pil) pil.remove();
            }
            var cancelBtn = actionsWrap.querySelector('[data-sub-action="cancel"]');
            if (cancelBtn) {
              cancelBtn.disabled = false;
            } else {
              actionsWrap.insertAdjacentHTML('beforeend', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="cancel">CANCEL</button>');
            }
          }
          var initialStatus = '';
          var contentNode = container.querySelector('[data-sub-status]');
          if (contentNode) initialStatus = String(contentNode.getAttribute('data-sub-status') || '').toUpperCase();
          if (!initialStatus) {
            var badgeNow = container.querySelector('.order-detail-ufc__status-badge');
            if (badgeNow) {
              var t = String(badgeNow.textContent || '').trim().toUpperCase();
              if (t === 'CANCELLED' || t === 'CANCELED') initialStatus = 'CANCELLED';
              else if (t === 'PAUSED') initialStatus = 'PAUSED';
              else if (t === 'ACTIVE') initialStatus = 'ACTIVE';
            }
          }
          if (initialStatus) applyStatusToUi(initialStatus);
          container.addEventListener('click', function(e) {
            var btn = e.target && e.target.closest && e.target.closest('.order-detail-ufc__sub-btn[data-sub-action]');
            if (!btn) return;
            var action = btn.getAttribute('data-sub-action');
            if (!action) return;
            var updateApi = (container.getAttribute && container.getAttribute('data-update-api')) || '';
            var apiKey = (container.getAttribute && container.getAttribute('data-api-key')) || '';
            var contentEl = container.querySelector('[data-contract-id]');
            var contractId = contentEl ? contentEl.getAttribute('data-contract-id') : '';
            var msgEl = document.getElementById('sub-detail-api-status-msg');
            function showMsg(text, isError) {
              if (!msgEl) return;
              msgEl.textContent = text;
              msgEl.style.display = 'block';
              msgEl.style.background = isError ? '#fef2f2' : '#f0fdf4';
              msgEl.style.color = isError ? '#dc2626' : '#166534';
            }
            function hideMsg() { if (msgEl) { msgEl.style.display = 'none'; msgEl.textContent = ''; } }
            /* Pause → 打开 Modal 弹窗 */
            if (action === 'pause') {
              hideMsg();
              var customerEmail = ufcSubDetailCustomerEmail();
              window.openPauseModal(contractId, customerEmail, function(result) {
                try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
                if (result.ok && result.data && result.data.ok) {
                  applyStatusToUi(result.data.appstleStatus || 'PAUSED');
                  var osr = result.data.shopifyOrderResult;
                  var orderMsg = '';
                  if (osr === 'cancelled') orderMsg = ' Current order cancelled and refunded.';
                  else if (osr === 'pause_current_order_cancelled') orderMsg = ' Current order cancelled and refunded.';
                  else if (osr === 'pause_no_matching_open_order') orderMsg = '';
                  var pauseSummary = '';
                  if (result.data.pauseWeeks && result.data.pauseResumeDate) {
                    pauseSummary = 'for ' + result.data.pauseWeeks + ' weeks. Will resume on ' + new Date(result.data.pauseResumeDate).toLocaleDateString('en-US', {month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}) + '.';
                  } else {
                    pauseSummary = 'indefinitely (no auto-resume date).';
                  }
                  showMsg('Subscription paused ' + pauseSummary + orderMsg, false);
                  /* 显示 pause info */
                  var topRow = container.querySelector('.order-detail-ufc__top-row');
                  if (topRow && result.data.pauseResumeDate) {
                    var existing = topRow.parentNode.querySelector('.pause-info-line');
                    if (existing) existing.remove();
                    var rd = new Date(result.data.pauseResumeDate);
                    var now = new Date();
                    var daysLeft = Math.max(0, Math.ceil((rd - now) / 86400000));
                    topRow.insertAdjacentHTML('afterend', '<p class="pause-info-line" style="font-size:14px;color:#6b7280;margin:8px 0 16px;">⏸ Paused until ' + rd.toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}) + ' (' + daysLeft + ' days remaining)</p>');
                  }
                } else {
                  showMsg('Pause failed: ' + ((result.data && result.data.error) || 'Please try again.'), true);
                }
              });
              return;
            }
            /* Extend Pause → 与 Pause 同风格的 pill 弹窗（替代原 prompt） */
            if (action === 'extend-pause') {
              hideMsg();
              var maxExtBtn = parseInt(btn.getAttribute('data-max-extend') || '4', 10);
              if (!isFinite(maxExtBtn) || maxExtBtn < 1) maxExtBtn = 4;
              maxExtBtn = Math.min(4, Math.max(1, maxExtBtn));
              function runExtendPauseFetch(extWeeks) {
                btn.disabled = true;
                btn.textContent = 'EXTENDING...';
                var customerEmail = ufcSubDetailCustomerEmail();
                // Storefront path only. The Partner Dashboard App Proxy target already
                // includes /signup-and-invite; adding it here duplicates the prefix.
                fetchJsonWithPathFallback([
                  '/apps/ufc-ignite/extend-pause',
                ], {
                  method: 'POST', credentials: 'same-origin',
                  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                  body: JSON.stringify({ contractId: contractId, customerEmail: customerEmail, extendWeeks: extWeeks })
                }, 60000)
                  .then(function(result) {
                    try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
                    if (result.ok && result.data.ok) {
                      showMsg('Pause extended by ' + result.data.extendWeeks + ' week' + (result.data.extendWeeks > 1 ? 's' : '') + '. New resume date: ' + (result.data.newResumeDateHuman || result.data.newResumeDate) + '. Total pause: ' + result.data.totalPauseWeeks + ' of 8 weeks.', false);
                      /* 更新 pause info banner */
                      var banner = container.querySelector('.pause-info-banner');
                      if (banner && result.data.newResumeDate) {
                        var nrd = new Date(result.data.newResumeDate);
                        var nDays = Math.max(0, Math.ceil((nrd - new Date()) / 86400000));
                        var nrdFmt = nrd.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
                        var maxExt = Math.max(0, 8 - result.data.totalPauseWeeks);
                        banner.innerHTML = '<div class="pause-info-banner__label">⏸ Subscription Paused</div>' +
                          '<div><strong>Resumes:</strong> ' + nrdFmt + ' (' + nDays + ' days remaining)</div>';
                        if (maxExt <= 0) btn.style.display = 'none';
                        else btn.setAttribute('data-max-extend', String(Math.min(4, maxExt)));
                      }
                      /* 更新 pause-info-line（如果存在） */
                      var pil = container.querySelector('.pause-info-line');
                      if (pil && result.data.newResumeDate) {
                        var nrd2 = new Date(result.data.newResumeDate);
                        var nDays2 = Math.max(0, Math.ceil((nrd2 - new Date()) / 86400000));
                        pil.innerHTML = '⏸ Paused until ' + nrd2.toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}) + ' (' + nDays2 + ' days remaining)';
                      }
                    } else {
                      var errMsg = (result.data && result.data.error) || 'Please try again.';
                      if (result.data && result.data.maxAllowedExtendWeeks != null) {
                        errMsg += ' Maximum additional weeks: ' + result.data.maxAllowedExtendWeeks + '.';
                      }
                      showMsg('Extend failed: ' + errMsg, true);
                    }
                    btn.disabled = false;
                    btn.textContent = 'EXTEND PAUSE';
                  })
                  .catch(function(err) {
                    btn.disabled = false;
                    btn.textContent = 'EXTEND PAUSE';
                    showMsg('Extend failed: ' + (err.message || 'Please try again.'), true);
                  });
              }
              if (typeof window.openExtendPauseModal === 'function') {
                window.openExtendPauseModal(maxExtBtn, function(chosenWeeks) {
                  if (chosenWeeks == null) return;
                  runExtendPauseFetch(chosenWeeks);
                });
              } else {
                /* 模态不存在时的兜底（无障碍降级） */
                var extWeeks = parseInt(prompt('How many weeks would you like to extend your pause? (1-' + maxExtBtn + ')'), 10);
                if (!extWeeks || extWeeks < 1 || extWeeks > maxExtBtn) {
                  if (extWeeks !== null && !isNaN(extWeeks)) showMsg('Please enter a number between 1 and ' + maxExtBtn + '.', true);
                  return;
                }
                runExtendPauseFetch(extWeeks);
              }
              return;
            }
            hideMsg();
            if (!updateApi || !contractId) {
              showMsg('Subscription update is not configured. Please use the subscription portal or contact support.', true);
              return;
            }
            var customerEmail = ufcSubDetailCustomerEmail();
            if (action === 'cancel') {
              if (!btn.__cancelConfirmed) {
                if (typeof window.openCancelModal === 'function') {
                  window.openCancelModal(contractId, customerEmail, function(ok) {
                    if (!ok) return;
                    btn.__cancelConfirmed = true;
                    btn.click();
                  });
                  return;
                }
                if (!confirm('Are you sure you want to cancel this subscription? This cannot be undone. Your current order will be cancelled and refunded.')) return;
              }
              btn.__cancelConfirmed = false;
            } else if (action === 'resume') {
              if (!btn.__resumeConfirmed) {
                if (typeof window.openResumeModal === 'function') {
                  window.openResumeModal(function(ok) {
                    if (!ok) return;
                    btn.__resumeConfirmed = true;
                    btn.click();
                  });
                  return;
                }
                if (!confirm('Are you sure you want to resume this subscription?')) return;
              }
              btn.__resumeConfirmed = false;
            }
            var status = mapActionToStatus(action);
            if (!status) return;
            var url = updateApi + (updateApi.indexOf('?') >= 0 ? '&' : '?') + 'contractId=' + encodeURIComponent(contractId) + '&status=' + encodeURIComponent(status);
            btn.disabled = true;
            var headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
            var manageApiPaths = [
              '/apps/ufc-ignite/manage-subscription',
              '/apps/ufc-ignite/signup-and-invite/manage-subscription',
            ];
            var rrDetail = window.__ufcPendingRefundReason || {};
            var manageBody = { action: action, contractId: contractId, customerEmail: customerEmail };
            if (action === 'cancel') {
              manageBody.refundReasonCode = rrDetail.code || 'unknown';
              manageBody.refundReasonDetail = rrDetail.detail || '';
              window.__ufcPendingRefundReason = null;
            }
            fetchJsonWithPathFallback(manageApiPaths, { method: 'POST', credentials: 'same-origin', headers: headers, body: JSON.stringify(manageBody) }, 60000)
              .then(function(result) {
                try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
                if (result.ok && result.data.ok) {
                  applyStatusToUi(result.data.appstleStatus || status);
                  var osr = result.data.shopifyOrderResult;
                  var orderMsg = '';
                  var orderErr = false;
                  if (osr === 'cancelled') orderMsg = ' Order cancelled.';
                  else if (osr === 'closed') orderMsg = ' Order closed.';
                  else if (osr === 'reopened') orderMsg = ' Order reopened.';
                  else if (osr === 'reopen_failed_permanently_cancelled') orderMsg = ' Note: order was permanently cancelled and cannot be reopened.';
                  else if (osr === 'pause_current_order_kept') orderMsg = ' Paused: current delivery order kept; subscription paused in Appstle.';
                  else if (osr === 'pause_no_matching_open_order') orderMsg = ' Paused in Appstle: no open subscription-tagged order matched in Shopify.';
                  else if (osr === 'cancel_no_matching_open_order') orderMsg = ' Cancelled in Appstle: no open subscription-tagged order matched to cancel in Shopify.';
                  else if (osr === 'cancel_failed_closed') {
                    var detail = result.data.cancelFailDetail || {};
                    orderMsg = ' Cancel failed → order closed instead. ' + (detail.errorSummary || '');
                    orderErr = false;
                  }
                  else if (osr === 'cancel_failed') {
                    var detail = result.data.cancelFailDetail || {};
                    orderMsg = ' Cancelled in Appstle, but Shopify order cancel AND close both failed (HTTP ' + (detail.httpStatus || '?') + '). ' + (detail.errorSummary || 'Contact support if needed.');
                    orderErr = true;
                  }
                  else if (osr === 'skipped_payment_not_ready') {
                    orderMsg = ' Cancelled in Appstle: Shopify order not eligible to cancel yet (payment ' + (result.data.cancelFailDetail && result.data.cancelFailDetail.financialStatus || 'pending/voided') + ').';
                    orderErr = true;
                  }
                  else if (osr === 'resumed_pause_order_kept') orderMsg = ' Subscription resumed. Current order was kept (not re-opened).';
                  else if (osr === 'resumed_cancelled_order_kept') orderMsg = ' Subscription resumed.';
                  else if (osr === 'resume_pause_no_open_order_for_audit') orderMsg = ' Subscription resumed in Appstle. No open subscription-tagged order matched for note/tag.';
                  else if (osr === 'resume_cancelled_no_open_order_for_audit') orderMsg = ' Subscription resumed in Appstle.';
                  else if (osr === 'resume_no_cancelled_order_to_reopen') orderMsg = ' Subscription resumed in Appstle. No cancelled subscription-tagged order found to re-open in Shopify.';
                  else if (osr === 'resume_appstle_only') orderMsg = ' Appstle subscription resumed (Shopify order not touched).';
                  var isCancelSuccess = action === 'cancel';
                  var orderIssue = orderErr || osr === 'reopen_failed_permanently_cancelled';
                  if (isCancelSuccess && !orderIssue) {
                    showMsg('Subscription canceled.', false);
                  } else if (isCancelSuccess && orderIssue) {
                    showMsg('Subscription canceled.' + orderMsg, true);
                  } else {
                    showMsg('Subscription updated.' + orderMsg, orderErr || osr === 'reopen_failed_permanently_cancelled');
                  }
                } else {
                  showMsg('Update failed: ' + ((result.data && result.data.error) || 'Please try again.'), true);
                }
                btn.disabled = false;
              })
              .catch(function(err) { btn.disabled = false; showMsg('Update failed: ' + (err.message || 'Please try again.'), true); });
          });
          var payBtn = container.querySelector('#paymentUpdateBtn');
          if (payBtn) {
            payBtn.addEventListener('click', function() {
              var contentEl = container.querySelector('[data-contract-id]');
              var cid = contentEl ? contentEl.getAttribute('data-contract-id') : '';
              var payMsg = document.getElementById('paymentUpdateMsg');
              function showPayMsg(text, isError) {
                if (!payMsg) return;
                payMsg.textContent = text;
                payMsg.style.display = 'block';
                payMsg.style.background = isError ? '#fef2f2' : '#f0fdf4';
                payMsg.style.color = isError ? '#dc2626' : '#166534';
              }
              if (!cid) { showPayMsg('Cannot identify subscription. Please contact support.', true); return; }
              var root = document.getElementById('sub-detail-load-by-id');
              var shopOrigin = (root && root.getAttribute('data-shop-origin')) || window.location.origin;
              shopOrigin = String(shopOrigin).replace(/\/$/, '');
              var custEmail = (root && root.getAttribute('data-customer-email')) || '';
              var portalUrl = (root && root.getAttribute('data-payment-update-url')) || '';
              if (portalUrl && (portalUrl.indexOf('http') === 0 || portalUrl.indexOf('//') === 0)) {
                window.open(portalUrl, '_blank', 'noopener');
                return;
              }
              var qs = 'contractId=' + encodeURIComponent(cid);
              if (custEmail) qs += '&email=' + encodeURIComponent(custEmail);
              window.location.href = shopOrigin + '/apps/ufc-ignite/begin-payment-update?' + qs;
            });
          }
        }
        function showNotFound(msg) {
          wrap.innerHTML = '<p>Subscription not found.</p><a href="' + backUrl + '">Back to Subscriptions</a>';
        }
        if (tryRenderFromCache()) return;
        wrap.innerHTML = '<p style="padding:24px 16px;text-align:center;color:#6b7280;font-size:14px;">Loading subscription details…</p>';
        var headers = { 'Accept': 'application/json' };
        (window.ufcFetchWithTimeout || fetch)(apiUrl || fallbackUrl, { credentials: (apiUrl && useCredentials) ? 'include' : 'omit', headers: headers }, 25000)
          .then(function(r){
            if (!r.ok) return null;
            return r.json().catch(function(){ return null; });
          })
          .then(function(data){
            if (data) { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: data })); } catch(e){} }
            if (!data || !renderFromData(data, apiUrl && !apiUrl.match(/^https:\/\//) ? 'App Proxy' : 'Direct API', apiUrl || fallbackUrl)) {
              showNotFound(data ? ('列表条数: ' + ((data.content && data.content.length) || 0) + '，未匹配 id=' + subId) : null);
            }
          })
          .catch(function(err){
            wrap.innerHTML = '<p>Could not load subscription.</p><a href="' + backUrl + '">Back to Subscriptions</a>';
          });
      })();
          (function() {
            document.querySelectorAll('[data-liquid-manage]').forEach(function(btn) {
              btn.addEventListener('click', function() {
                var a = btn.getAttribute('data-liquid-manage');
                if (a === 'allergen') {
                  var ag = document.getElementById('sub-detail-allergens');
                  if (ag) ag.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else if (a === 'payment') {
                  var p = document.getElementById('paymentUpdateBtnLiquid');
                  if (p) p.click();
                }
              });
            });
          })();
          (function() {
            var btn = document.getElementById('paymentUpdateBtnLiquid');
            if (!btn) return;
            var shopOrigin = ufcSubDetailShopOrigin();
            var custEmail = ufcSubDetailCustomerEmail();
            var portalUrl = ufcSubDetailPaymentUpdateUrl();
            btn.addEventListener('click', function() {
              var msgEl = document.getElementById('paymentUpdateMsgLiquid');
              function showMsg(text, isError) {
                if (!msgEl) return;
                msgEl.textContent = text;
                msgEl.style.display = 'block';
                msgEl.style.background = isError ? '#fef2f2' : '#f0fdf4';
                msgEl.style.color = isError ? '#dc2626' : '#166534';
              }
              var contractId = new URLSearchParams(window.location.search).get('subscription') || '';
              if (!contractId) { showMsg('Cannot identify subscription. Please contact support.', true); return; }
              if (portalUrl && (portalUrl.indexOf('http') === 0 || portalUrl.indexOf('//') === 0)) {
                window.open(portalUrl, '_blank', 'noopener');
                return;
              }
              var base = String(shopOrigin || window.location.origin).replace(/\/$/, '');
              var qs = 'contractId=' + encodeURIComponent(contractId);
              if (custEmail) qs += '&email=' + encodeURIComponent(custEmail);
              window.location.href = base + '/apps/ufc-ignite/begin-payment-update?' + qs;
            });
          })();
      (function() {
        var form = document.getElementById('sub-detail-allergen-form');
        var input = document.getElementById('sub-detail-allergen-input');
        var msg = document.getElementById('sub-detail-allergen-msg');
        var pills = form ? form.querySelectorAll('.sub-detail__allergen-pill') : [];

        function getSelected() {
          var selected = [];
          pills.forEach(function(pill) {
            if (pill.classList.contains('is-selected')) selected.push(pill.getAttribute('data-allergen'));
          });
          return selected;
        }

        function syncInput() {
          if (input) input.value = getSelected().join(',');
        }

        pills.forEach(function(pill) {
          pill.addEventListener('click', function() {
            this.classList.toggle('is-selected');
            this.setAttribute('aria-pressed', this.classList.contains('is-selected'));
            syncInput();
          });
        });
        syncInput();

        if (form) {
          form.addEventListener('submit', function(e) {
            var endpoint = form.getAttribute('data-allergen-endpoint');
            if (!endpoint || endpoint === '') {
              e.preventDefault();
              if (msg) {
                msg.textContent = 'Please set "Allergen update URL" in theme settings to save.';
                msg.classList.add('is-visible', 'is-error');
              }
              return;
            }
            input.value = getSelected().join(',');
          });
        }
      })();

      (function() {
        var wrap = document.getElementById('account-ufc-subscription-detail-wrap');
        var actionsEl = document.getElementById('sub-detail-actions');
        var statusMsg = document.getElementById('sub-detail-status-msg');
        if (!wrap || !actionsEl) return;
        var orderId = wrap.getAttribute('data-order-id');
        var contractIdFromMeta = (wrap.getAttribute('data-contract-id') || '').trim();
        var listApi = (wrap.getAttribute('data-appstle-list-api') || '').trim();
        var updateApi = (wrap.getAttribute('data-appstle-update-api') || '').trim();
        var skipOrderApi = (wrap.getAttribute('data-appstle-skip-order-api') || '').trim();
        var apiKey = (wrap.getAttribute('data-appstle-api-key') || '').trim();
        var fallbackUrl = actionsEl.getAttribute('data-fallback-url') || '';
        function appstleHeaders() {
          return { 'Accept': 'application/json' };
        }

        function showStatusMsg(text, isError) {
          if (!statusMsg) return;
          statusMsg.textContent = text;
          statusMsg.style.display = 'block';
          statusMsg.classList.toggle('is-error', !!isError);
          statusMsg.classList.toggle('is-visible', true);
        }
        function hideStatusMsg() {
          if (statusMsg) { statusMsg.style.display = 'none'; statusMsg.textContent = ''; }
        }
        function removeRetestCancelButtons() {
          var nodes = document.querySelectorAll('button, a');
          nodes.forEach(function(node) {
            var txt = String(node.textContent || '').trim().toLowerCase();
            if (txt.indexOf('re-test cancel') >= 0 || txt.indexOf('retest cancel') >= 0) node.remove();
          });
        }

        function parseContractId(id) {
          if (id == null || id === '') return '';
          var s = String(id).trim();
          var gidMatch = s.match(/\/SubscriptionContract\/(\d+)$/) || s.match(/\/(\d+)$/);
          if (gidMatch) return gidMatch[1];
          if (/^\d+$/.test(s)) return s;
          return s;
        }

        function getContractId(cb) {
          var cid = parseContractId(contractIdFromMeta);
          if (cid) { cb(cid); return; }
          if (!listApi || !orderId) { cb(''); return; }
          (window.ufcFetchWithTimeout || fetch)(listApi, { credentials: 'same-origin', headers: appstleHeaders() }, 25000)
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(data) {
              if (!data) { cb(''); return; }
              var list = Array.isArray(data) ? data : (data.subscriptions || data.contracts || data.data && (data.data.subscriptions || data.data.contracts) || []);
              if (!Array.isArray(list)) { cb(''); return; }
              var oid = String(orderId).trim();
              var oidNum = oid.replace(/\D/g, '');
              for (var i = 0; i < list.length; i++) {
                var s = list[i];
                var soid = (s.order_id != null ? String(s.order_id) : (s.shopify_order_id != null ? String(s.shopify_order_id) : ''));
                if (s.origin_order && s.origin_order.id != null) soid = String(s.origin_order.id);
                if (s.originOrderId != null) soid = String(s.originOrderId);
                var soidNum = soid.replace(/\D/g, '');
                if (soid === oid || soidNum === oidNum || soid === ('gid://shopify/Order/' + oid)) {
                  var id = s.id != null ? s.id : (s.subscription_id != null ? s.subscription_id : (s.contract_id != null ? s.contract_id : ''));
                  cb(parseContractId(id));
                  return;
                }
              }
              cb('');
            })
            .catch(function() { cb(''); });
        }

        function mapActionToStatus(action) {
          if (action === 'resume') return 'ACTIVE';
          if (action === 'pause') return 'PAUSED';
          if (action === 'cancel') return 'CANCELLED';
          return '';
        }
        function applyStatusToUi(status) {
          var s = String(status || '').toUpperCase();
          var root = document.querySelector('.order-detail-ufc');
          if (root) {
            var badge = root.querySelector('.order-detail-ufc__status-badge');
            if (badge) {
              badge.textContent = s === 'ACTIVE' ? 'Active' : (s === 'PAUSED' ? 'Paused' : (s === 'CANCELLED' ? 'Cancelled' : s));
              badge.classList.toggle('order-detail-ufc__status-badge--active', s === 'ACTIVE');
              badge.classList.toggle('order-detail-ufc__status-badge--paused', s === 'PAUSED');
            }
          }
          if (!actionsEl) return;
          var toggleBtn = actionsEl.querySelector('[data-sub-action="resume"], [data-sub-action="pause"]');
          var cancelBtn = actionsEl.querySelector('[data-sub-action="cancel"]');
          var extendBtn = actionsEl.querySelector('[data-sub-action="extend-pause"]');
          if (s === 'CANCELLED') {
            // Cancelled 状态仍允许恢复：保留/创建 RESUME，移除 CANCEL 与 EXTEND
            if (toggleBtn) {
              toggleBtn.setAttribute('data-sub-action', 'resume');
              toggleBtn.textContent = 'RESUME';
              toggleBtn.disabled = false;
            } else if (actionsEl) {
              actionsEl.insertAdjacentHTML('afterbegin', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="resume">RESUME</button>');
            }
            if (cancelBtn) cancelBtn.remove();
            if (extendBtn) extendBtn.remove();
            removeRetestCancelButtons();
            return;
          }
          if (s === 'PAUSED') {
            if (toggleBtn) {
              toggleBtn.setAttribute('data-sub-action', 'resume');
              toggleBtn.textContent = 'RESUME';
              toggleBtn.disabled = false;
            } else if (actionsEl) {
              actionsEl.insertAdjacentHTML('afterbegin', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="resume">RESUME</button>');
            }
          } else {
            if (toggleBtn) {
              toggleBtn.setAttribute('data-sub-action', 'pause');
              toggleBtn.textContent = 'PAUSE';
              toggleBtn.disabled = false;
            } else if (actionsEl) {
              actionsEl.insertAdjacentHTML('afterbegin', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="pause">PAUSE</button>');
            }
          }
          if (cancelBtn) {
            cancelBtn.disabled = false;
          } else if (actionsEl) {
            actionsEl.insertAdjacentHTML('beforeend', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="cancel">CANCEL</button>');
          }
          removeRetestCancelButtons();
          /* Extend Pause 按钮：仅 PAUSED 状态显示 */
          var extendBtn2 = actionsEl.querySelector('[data-sub-action="extend-pause"]');
          if (s === 'PAUSED') {
            if (!extendBtn2) {
              var cancelRef2 = actionsEl.querySelector('[data-sub-action="cancel"]');
              if (cancelRef2) {
                cancelRef2.insertAdjacentHTML('beforebegin', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="extend-pause">EXTEND PAUSE</button>');
              } else {
                actionsEl.insertAdjacentHTML('beforeend', '<button type="button" class="order-detail-ufc__sub-btn" data-sub-action="extend-pause">EXTEND PAUSE</button>');
              }
            }
          } else {
            if (extendBtn2) extendBtn2.remove();
            /* 移除 pause info */
            var pib2 = document.querySelector('.pause-info-banner');
            if (pib2) pib2.remove();
            var pil2 = document.querySelector('.pause-info-line');
            if (pil2) pil2.remove();
          }
        }

        actionsEl.querySelectorAll('.order-detail-ufc__sub-btn[data-sub-action], .sub-detail__btn[data-sub-action]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var action = this.getAttribute('data-sub-action');
            if (!action) return;
            /* Pause → 打开 Modal 弹窗 */
            if (action === 'pause') {
              hideStatusMsg();
              getContractId(function(contractId) {
                if (!contractId) {
                  showStatusMsg('Could not find subscription contract. Try the subscription portal or contact support.', true);
                  return;
                }
                var customerEmail2 = ufcSubDetailCustomerEmail();
                window.openPauseModal(contractId, customerEmail2, function(result) {
                  try { sessionStorage.removeItem('ufc_subs_cache'); } catch (e) {}
                  if (result.ok && result.data && result.data.ok) {
                    applyStatusToUi(result.data.appstleStatus || 'PAUSED');
                    var osr2 = result.data.shopifyOrderResult;
                    var orderMsg2 = '';
                    if (osr2 === 'cancelled') orderMsg2 = ' Current order cancelled and refunded.';
                    else if (osr2 === 'pause_current_order_cancelled') orderMsg2 = ' Current order cancelled and refunded.';
                    else if (osr2 === 'pause_no_matching_open_order') orderMsg2 = '';
                    var pauseSummary2 = '';
                    if (result.data.pauseWeeks && result.data.pauseResumeDate) {
                      pauseSummary2 = 'for ' + result.data.pauseWeeks + ' weeks. Will resume on ' + new Date(result.data.pauseResumeDate).toLocaleDateString('en-US', {month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}) + '.';
                    } else {
                      pauseSummary2 = 'indefinitely (no auto-resume date).';
                    }
                    showStatusMsg('Subscription paused ' + pauseSummary2 + orderMsg2, false);
                    /* 显示 pause info */
                    var topRow = document.querySelector('.order-detail-ufc__top-row');
                    if (topRow && result.data.pauseResumeDate) {
                      var existing = topRow.parentNode.querySelector('.pause-info-line');
                      if (existing) existing.remove();
                      var rd = new Date(result.data.pauseResumeDate);
                      var now = new Date();
                      var daysLeft = Math.max(0, Math.ceil((rd - now) / 86400000));
                      topRow.insertAdjacentHTML('afterend', '<p class="pause-info-line" style="font-size:14px;color:#6b7280;margin:8px 0 16px;">⏸ Paused until ' + rd.toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}) + ' (' + daysLeft + ' days remaining)</p>');
                    }
                  } else {
                    showStatusMsg('Pause failed: ' + ((result.data && result.data.error) || 'Please try again.'), true);
                  }
                });
              });
              return;
            }
            /* Extend Pause → 与 Pause 同风格的弹窗选周数 */
            if (action === 'extend-pause') {
              hideStatusMsg();
              var maxExtD = parseInt(btn.getAttribute('data-max-extend') || '4', 10);
              if (!isFinite(maxExtD) || maxExtD < 1) maxExtD = 4;
              maxExtD = Math.min(4, Math.max(1, maxExtD));
              function runExtendPauseDetailFetch(contractId, extWeeks2) {
                btn.disabled = true;
                btn.textContent = 'EXTENDING...';
                var customerEmail2 = ufcSubDetailCustomerEmail();
                var extendPayload2 = JSON.stringify({ contractId: contractId, customerEmail: customerEmail2, extendWeeks: extWeeks2 });
                // Storefront path only. App Proxy maps this to the backend
                // /signup-and-invite/extend-pause route configured in Partner Dashboard.
                var extendUrls2 = ['/apps/ufc-ignite/extend-pause'];
                function extendPausePostOneDetail(i) {
                  if (i >= extendUrls2.length) return Promise.resolve(null);
                  return (window.ufcFetchWithTimeout || fetch)(extendUrls2[i], {
                    method: 'POST', credentials: 'same-origin',
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    body: extendPayload2
                  }, 60000).then(function(r) {
                    return r.text().then(function(t) { return { r: r, t: t || '' }; });
                  }).then(function(ref) {
                    var d;
                    try {
                      d = ref.t ? JSON.parse(ref.t) : {};
                    } catch (parseErr) {
                      if (i + 1 < extendUrls2.length && (ref.r.status === 404 || /^\s*</i.test(ref.t))) return extendPausePostOneDetail(i + 1);
                      throw new Error('Server returned a page instead of JSON (extend-pause). Deploy the latest app or check App Proxy.');
                    }
                    if (ref.r.status === 404 && i + 1 < extendUrls2.length) return extendPausePostOneDetail(i + 1);
                    return { ok: ref.r.ok, data: d };
                  });
                }
                extendPausePostOneDetail(0).then(function(result) {
                    if (!result) {
                      btn.disabled = false;
                      btn.textContent = 'EXTEND PAUSE';
                      showStatusMsg('Extend failed: could not reach extend-pause API on any path. Please try again later.', true);
                      return;
                    }
                    try { sessionStorage.removeItem('ufc_subs_cache'); } catch (e) {}
                    if (result.ok && result.data.ok) {
                      showStatusMsg('Pause extended by ' + result.data.extendWeeks + ' week' + (result.data.extendWeeks > 1 ? 's' : '') + '. New resume date: ' + (result.data.newResumeDateHuman || result.data.newResumeDate) + '. Total pause: ' + result.data.totalPauseWeeks + ' of 8 weeks.', false);
                      var pil3 = document.querySelector('.pause-info-line');
                      if (pil3 && result.data.newResumeDate) {
                        var nrd3 = new Date(result.data.newResumeDate);
                        var nDays3 = Math.max(0, Math.ceil((nrd3 - new Date()) / 86400000));
                        pil3.innerHTML = '\u23f8 Paused until ' + nrd3.toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}) + ' (' + nDays3 + ' days remaining)';
                      }
                      var banner3 = document.querySelector('.pause-info-banner');
                      if (banner3 && result.data.newResumeDate) {
                        var nrd3b = new Date(result.data.newResumeDate);
                        var nDays3b = Math.max(0, Math.ceil((nrd3b - new Date()) / 86400000));
                        var nrdFmt3 = nrd3b.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
                        var maxExt3 = Math.max(0, 8 - result.data.totalPauseWeeks);
                        banner3.innerHTML = '<div class="pause-info-banner__label">\u23f8 Subscription Paused</div>' +
                          '<div><strong>Resumes:</strong> ' + nrdFmt3 + ' (' + nDays3b + ' days remaining)</div>';
                        if (maxExt3 <= 0) btn.style.display = 'none';
                      }
                      var extBtnUpd = actionsEl && actionsEl.querySelector('[data-sub-action="extend-pause"]');
                      if (extBtnUpd && result.data.totalPauseWeeks != null) {
                        var mxLeft = Math.max(0, 8 - result.data.totalPauseWeeks);
                        if (mxLeft <= 0) extBtnUpd.style.display = 'none';
                        else {
                          extBtnUpd.style.display = '';
                          extBtnUpd.setAttribute('data-max-extend', String(Math.min(4, mxLeft)));
                        }
                      }
                    } else {
                      var errMsg2 = (result.data && result.data.error) || 'Please try again.';
                      if (result.data && result.data.maxAllowedExtendWeeks != null) {
                        errMsg2 += ' Maximum additional weeks: ' + result.data.maxAllowedExtendWeeks + '.';
                      }
                      showStatusMsg('Extend failed: ' + errMsg2, true);
                    }
                    btn.disabled = false;
                    btn.textContent = 'EXTEND PAUSE';
                  })
                  .catch(function(err) {
                    btn.disabled = false;
                    btn.textContent = 'EXTEND PAUSE';
                    showStatusMsg('Extend failed: ' + (err.message || 'Please try again.'), true);
                  });
              }
              if (typeof window.openExtendPauseModal === 'function') {
                window.openExtendPauseModal(maxExtD, function(chosenWeeks) {
                  if (chosenWeeks == null) return;
                  getContractId(function(contractId) {
                    if (!contractId) {
                      showStatusMsg('Could not find subscription contract. Try the subscription portal or contact support.', true);
                      return;
                    }
                    runExtendPauseDetailFetch(contractId, chosenWeeks);
                  });
                });
              } else {
                getContractId(function(contractId) {
                  if (!contractId) {
                    showStatusMsg('Could not find subscription contract. Try the subscription portal or contact support.', true);
                    return;
                  }
                  var extWeeks2 = parseInt(prompt('How many weeks would you like to extend your pause? (1-4)'), 10);
                  if (!extWeeks2 || extWeeks2 < 1 || extWeeks2 > 4) {
                    if (extWeeks2 !== null && !isNaN(extWeeks2)) showStatusMsg('Please enter a number between 1 and 4.', true);
                    return;
                  }
                  runExtendPauseDetailFetch(contractId, extWeeks2);
                });
              }
              return;
            }
            if (action === 'cancel') {
              hideStatusMsg();
              if (!btn.__cancelConfirmed) {
                if (typeof window.openCancelModal === 'function') {
                  getContractId(function(cid) {
                    if (!cid) {
                      showStatusMsg('Could not find subscription contract. Try the subscription portal or contact support.', true);
                      return;
                    }
                    window.openCancelModal(cid, ufcSubDetailCustomerEmail(), function(ok) {
                      if (!ok) return;
                      btn.__cancelConfirmed = true;
                      btn.click();
                    });
                  });
                  return;
                }
                if (!confirm('Are you sure you want to cancel this subscription? This cannot be undone. Your current order will be cancelled and refunded.')) return;
              }
              btn.__cancelConfirmed = false;
            } else if (action === 'resume') {
              hideStatusMsg();
              if (!btn.__resumeConfirmed) {
                if (typeof window.openResumeModal === 'function') {
                  window.openResumeModal(function(ok) {
                    if (!ok) return;
                    btn.__resumeConfirmed = true;
                    btn.click();
                  });
                  return;
                }
                if (!confirm('Are you sure you want to resume this subscription?')) return;
              }
              btn.__resumeConfirmed = false;
            }
            hideStatusMsg();
            if (!updateApi) {
              if (fallbackUrl) {
                window.location.href = fallbackUrl + '?subscription=' + encodeURIComponent(orderId) + '&action=' + action;
              } else {
                showStatusMsg('Subscription management URL not configured.', true);
              }
              return;
            }
            getContractId(function(contractId) {
              if (!contractId) {
                showStatusMsg('Could not find subscription contract. Try the subscription portal or contact support.', true);
                return;
              }
              var status = mapActionToStatus(action);
              if (!status) return;
              var url = updateApi + (updateApi.indexOf('?') >= 0 ? '&' : '?') + 'contractId=' + encodeURIComponent(contractId) + '&status=' + encodeURIComponent(status);
              btn.disabled = true;
              var putHeaders = appstleHeaders();
              putHeaders['Content-Type'] = 'application/json';
              var manageApiPaths2 = [
                '/apps/ufc-ignite/manage-subscription',
                '/apps/ufc-ignite/signup-and-invite/manage-subscription',
              ];
              var customerEmail2 = ufcSubDetailCustomerEmail();
              var rrDetail = window.__ufcPendingRefundReason || {};
              var manageBodyDetail = { action: action, contractId: contractId, customerEmail: customerEmail2 };
              if (action === 'cancel') {
                manageBodyDetail.refundReasonCode = rrDetail.code || 'unknown';
                manageBodyDetail.refundReasonDetail = rrDetail.detail || '';
                window.__ufcPendingRefundReason = null;
              }
              fetchJsonWithPathFallback(manageApiPaths2, { method: 'POST', credentials: 'same-origin', headers: putHeaders, body: JSON.stringify(manageBodyDetail) }, 60000)
                .then(function(result) {
                  try { sessionStorage.removeItem('ufc_subs_cache'); } catch (e) {}
                  if (result.ok && result.data.ok) {
                    applyStatusToUi(result.data.appstleStatus || status);
                    var osr2 = result.data.shopifyOrderResult;
                    var orderMsg2 = '';
                    var orderErr2 = false;
                    if (osr2 === 'cancelled') orderMsg2 = ' Order cancelled.';
                    else if (osr2 === 'closed') orderMsg2 = ' Order closed.';
                    else if (osr2 === 'reopened') orderMsg2 = ' Order reopened.';
                    else if (osr2 === 'reopen_failed_permanently_cancelled') orderMsg2 = ' Note: order was permanently cancelled and cannot be reopened.';
                    else if (osr2 === 'pause_current_order_kept') orderMsg2 = ' Paused: current delivery order kept; subscription paused in Appstle.';
                    else if (osr2 === 'pause_no_matching_open_order') orderMsg2 = ' Paused in Appstle: no open subscription-tagged order matched in Shopify.';
                    else if (osr2 === 'cancel_no_matching_open_order') orderMsg2 = ' Cancelled in Appstle: no open subscription-tagged order matched to cancel in Shopify.';
                    else if (osr2 === 'cancel_failed_closed') {
                      var detail2 = result.data.cancelFailDetail || {};
                      orderMsg2 = ' Cancel failed → order closed instead. ' + (detail2.errorSummary || '');
                      orderErr2 = false;
                    }
                    else if (osr2 === 'cancel_failed') {
                      var detail2 = result.data.cancelFailDetail || {};
                      orderMsg2 = ' Cancelled in Appstle, but Shopify order cancel AND close both failed (HTTP ' + (detail2.httpStatus || '?') + '). ' + (detail2.errorSummary || 'Contact support if needed.');
                      orderErr2 = true;
                    }
                    else if (osr2 === 'skipped_payment_not_ready') {
                      orderMsg2 = ' Cancelled in Appstle: Shopify order not eligible to cancel yet (payment ' + (result.data.cancelFailDetail && result.data.cancelFailDetail.financialStatus || 'pending/voided') + ').';
                      orderErr2 = true;
                    }
                    else if (osr2 === 'resumed_pause_order_kept') orderMsg2 = ' Subscription resumed. Current order was kept (not re-opened).';
                    else if (osr2 === 'resumed_cancelled_order_kept') orderMsg2 = ' Subscription resumed.';
                    else if (osr2 === 'resume_pause_no_open_order_for_audit') orderMsg2 = ' Subscription resumed in Appstle. No open subscription-tagged order matched for note/tag.';
                    else if (osr2 === 'resume_cancelled_no_open_order_for_audit') orderMsg2 = ' Subscription resumed in Appstle.';
                    else if (osr2 === 'resume_no_cancelled_order_to_reopen') orderMsg2 = ' Subscription resumed in Appstle. No cancelled subscription-tagged order found to re-open in Shopify.';
                    else if (osr2 === 'resume_appstle_only') orderMsg2 = ' Appstle subscription resumed (Shopify order not touched).';
                    var isCancelSuccess2 = action === 'cancel';
                    var orderIssue2 = orderErr2 || osr2 === 'reopen_failed_permanently_cancelled';
                    if (isCancelSuccess2 && !orderIssue2) {
                      showStatusMsg('Subscription canceled.', false);
                    } else if (isCancelSuccess2 && orderIssue2) {
                      showStatusMsg('Subscription canceled.' + orderMsg2, true);
                    } else {
                      showStatusMsg('Subscription updated.' + orderMsg2, orderErr2 || osr2 === 'reopen_failed_permanently_cancelled');
                    }
                  } else {
                    showStatusMsg('Update failed: ' + ((result.data && result.data.error) || 'Please try again.'), true);
                  }
                  btn.disabled = false;
                })
                .catch(function(err) { btn.disabled = false; showStatusMsg('Update failed: ' + (err.message || 'Please try again.'), true); });
            });
          });
        });
      })();
(function() {
  var overlay = document.getElementById('managedSubOverlay');
  var segPause = document.getElementById('managedSegPause');
  var segCancel = document.getElementById('managedSegCancel');
  var panelPause = document.getElementById('managedPausePanel');
  var panelCancel = document.getElementById('managedCancelPanel');
  var closeTop = document.getElementById('managedSubClose');
  var keepBtn = document.getElementById('pauseModalKeep');
  var pauseFlowKeep1 = document.getElementById('pauseFlowKeep1');
  var pauseFlowStep1 = document.getElementById('pauseFlowStep1');
  var pauseFlowStep2Wrap = document.getElementById('pauseFlowStep2');
  var pauseFlowStep2Standard = document.getElementById('pauseFlowStep2Standard');
  var pauseFlowStep2Travel = document.getElementById('pauseFlowStep2Travel');
  var pauseFlowStep2TooMuch = document.getElementById('pauseFlowStep2TooMuch');
  var pauseFlowStep2Schedule = document.getElementById('pauseFlowStep2Schedule');
  var pauseFlowStep2Expensive = document.getElementById('pauseFlowStep2Expensive');
  var pauseFlowStep2Fatigue = document.getElementById('pauseFlowStep2Fatigue');
  var pauseFlowStep2Delivery = document.getElementById('pauseFlowStep2Delivery');
  var pauseFlowStep2Trying = document.getElementById('pauseFlowStep2Trying');
  var pauseTooMuchConfirmBtn = document.getElementById('pauseTooMuchConfirmBtn');
  var pauseTooMuchBack = document.getElementById('pauseTooMuchBack');
  var pauseFlowStep3Success = document.getElementById('pauseFlowStep3Success');
  var pauseTravelResumeInput = document.getElementById('pauseTravelResumeDateInput');
  var pauseTravelBack = document.getElementById('pauseTravelBack');
  var pauseTravelConfirmBtn = document.getElementById('pauseTravelConfirmBtn');
  var pauseSuccessDone = document.getElementById('pauseSuccessDone');
  var pauseFlowContinue = document.getElementById('pauseFlowContinue');
  var pauseFlowBack = document.getElementById('pauseFlowBack');
  var pauseOtherDetailLabel = document.getElementById('pauseOtherDetailLabel');
  var pauseDatePickerOverlay = document.getElementById('pauseDatePickerOverlay');
  var pauseDatePickerClose = document.getElementById('pauseDatePickerClose');
  var pauseDatePickerCancel = document.getElementById('pauseDatePickerCancel');
  var pauseDatePickerConfirm = document.getElementById('pauseDatePickerConfirm');
  var pauseDatePickerInput = document.getElementById('pauseDatePickerInput');
  var confirmBtn = document.getElementById('pauseModalConfirm');
  var pillsWrap = document.getElementById('pauseModalPills');
  var resumeDateText = document.getElementById('pauseModalResumeDateText');
  var cancelSurveyStep = document.getElementById('cancelSurveyStep');
  var cancelFlowStep2Expensive = document.getElementById('cancelFlowStep2Expensive');
  var cancelFlowStep2Delivery = document.getElementById('cancelFlowStep2Delivery');
  var cancelFlowStep2Quality = document.getElementById('cancelFlowStep2Quality');
  var cancelFlowStep2Fatigue = document.getElementById('cancelFlowStep2Fatigue');
  var cancelFlowStep2Lifestyle = document.getElementById('cancelFlowStep2Lifestyle');
  var cancelFlowStep3Optional = document.getElementById('cancelFlowStep3Optional');
  var cancelFinalStep = document.getElementById('cancelFinalStep');
  var cancelSurveyContinue = document.getElementById('cancelSurveyContinue');
  var cancelExpensiveProceedBtn = document.getElementById('cancelExpensiveProceedBtn');
  var cancelDeliveryProceedBtn = document.getElementById('cancelDeliveryProceedBtn');
  var cancelQualityProceedBtn = document.getElementById('cancelQualityProceedBtn');
  var cancelFatigueProceedBtn = document.getElementById('cancelFatigueProceedBtn');
  var cancelLifestyleProceedBtn = document.getElementById('cancelLifestyleProceedBtn');
  var cancelOptionalBack = document.getElementById('cancelOptionalBack');
  var cancelOptionalSubmitBtn = document.getElementById('cancelOptionalSubmitBtn');
  var cancelOptionalSkipBtn = document.getElementById('cancelOptionalSkipBtn');
  var cancelOptionalDetail = document.getElementById('cancelOptionalDetail');
  var cancelExpensiveReduceRow = document.getElementById('cancelExpensiveReduceRow');
  var cancelExpensiveReduceInput = document.getElementById('cancelExpensiveReduceInput');
  var cancelExpensiveReduceTitle = document.getElementById('cancelExpensiveReduceTitle');
  var cancelExpensiveReduceSub = document.getElementById('cancelExpensiveReduceSub');
  var cancelModalBack = document.getElementById('cancelModalBack');
  var finalBtn = document.getElementById('cancelModalFinal');
  var cancelFinalReasonSummary = document.getElementById('cancelFinalReasonSummary');
  var cancelRefundDetail = document.getElementById('cancelRefundReasonDetail');
  var cancelFinalOtherLabel = document.getElementById('cancelFinalOtherLabel');
  function forceEnglishDateInput(inputEl) {
    if (!inputEl) return;
    inputEl.setAttribute('lang', 'en-US');
    inputEl.setAttribute('data-locale', 'en-US');
  }
  forceEnglishDateInput(pauseTravelResumeInput);
  forceEnglishDateInput(pauseDatePickerInput);
  if (!overlay || !panelPause || !panelCancel) return;
  overlay.querySelectorAll('.pause-travel-data-cap').forEach(function(el) { el.style.display = 'none'; });

  var MANAGED_SCROLL_LIST_IDS = [
    'managedPauseReasonList', 'managedCancelReasonList', 'cancelExpensiveOfferList', 'cancelDeliveryList',
    'cancelQualityList', 'cancelFatigueList', 'managedPauseTooMuchList', 'managedPauseScheduleList',
    'managedPauseExpensiveList', 'managedPauseFatigueList', 'managedPauseDeliveryList', 'managedPauseTryingList'
  ];

  function isManagedElVisible(el) {
    if (!el || el.style.display === 'none') return false;
    return el.getClientRects().length > 0;
  }

  function isScrollablePane(el) {
    if (!el || !isManagedElVisible(el)) return false;
    var oy = window.getComputedStyle(el).overflowY;
    if (oy !== 'auto' && oy !== 'scroll' && oy !== 'overlay') return false;
    return el.scrollHeight > el.clientHeight + 2;
  }

  function findManagedOverlayScrollPane(fromEl) {
    var node = fromEl;
    while (node && node !== overlay) {
      if (isScrollablePane(node)) return node;
      node = node.parentElement;
    }
    for (var i = 0; i < MANAGED_SCROLL_LIST_IDS.length; i++) {
      var list = document.getElementById(MANAGED_SCROLL_LIST_IDS[i]);
      if (isScrollablePane(list)) return list;
    }
    return null;
  }

  function onManagedOverlayWheel(e) {
    if (!overlay.classList.contains('is-open')) return;
    var pane = findManagedOverlayScrollPane(e.target);
    if (!pane) {
      e.preventDefault();
      return;
    }
    var maxScroll = pane.scrollHeight - pane.clientHeight;
    var next = pane.scrollTop + e.deltaY;
    if (next < 0) next = 0;
    if (next > maxScroll) next = maxScroll;
    pane.scrollTop = next;
    e.preventDefault();
  }

  overlay.addEventListener('wheel', onManagedOverlayWheel, { passive: false, capture: true });

  var _pauseSelectedWeeks = 0;
  var _pauseTooMuchSub = '';
  var _pauseTooMuchQty = null;
  var _pauseScheduleSub = '';
  var _pauseScheduleQty = null;
  var _pauseExpensiveSub = '';
  var _pauseExpensiveQty = null;
  var _pauseFatigueSub = '';
  var _pauseDeliverySub = '';
  var _pauseTryingSub = '';
  var _pauseStep2PanelIds = ['pauseFlowStep2Standard','pauseFlowStep2Travel','pauseFlowStep2TooMuch','pauseFlowStep2Schedule','pauseFlowStep2Expensive','pauseFlowStep2Fatigue','pauseFlowStep2Delivery','pauseFlowStep2Trying'];
  var _pauseMealSelectionUrl = '/pages/meal-selection';
  var _pauseDatePickerCallback = null;
  var _pauseContractId = '';
  var _pauseCustomerEmail = '';
  var _pauseCallback = null;
  var _lastPauseResult = null;
  var _cancelCallback = null;
  var _cancelResolved = false;
  var _cancelExpensiveOffer = '';
  var _cancelDeliverySub = '';
  var _cancelQualitySub = '';
  var _cancelFatigueSub = '';
  var _cancelLifestyleOffer = '';
  var _cancelOptionalMeta = { reason: '', subreason: '', saveShown: 'No', saveAccepted: 'No' };
  function hideAllCancelStep2Panels() {
    if (cancelFlowStep2Expensive) cancelFlowStep2Expensive.style.display = 'none';
    if (cancelFlowStep2Delivery) cancelFlowStep2Delivery.style.display = 'none';
    if (cancelFlowStep2Quality) cancelFlowStep2Quality.style.display = 'none';
    if (cancelFlowStep2Fatigue) cancelFlowStep2Fatigue.style.display = 'none';
    if (cancelFlowStep2Lifestyle) cancelFlowStep2Lifestyle.style.display = 'none';
    if (cancelFlowStep3Optional) cancelFlowStep3Optional.style.display = 'none';
  }
  function setCancelSubTag(tagId, value, emptyText) {
    var el = document.getElementById(tagId);
    if (!el) return;
    el.textContent = value ? value : emptyText;
  }
  function getCurrentMealsPerWeek() {
    var textSources = [];
    var statVals = document.querySelectorAll('.sub-detail-v2__stat-value');
    statVals.forEach(function(el) { textSources.push(String(el.textContent || '')); });
    var planMeta = document.querySelector('.order-detail-ufc__plan-meta');
    if (planMeta) textSources.push(String(planMeta.textContent || ''));
    for (var i = 0; i < textSources.length; i++) {
      var m = textSources[i].match(/(\d+)\s*meals?/i);
      if (m) return parseInt(m[1], 10) || 0;
    }
    return 0;
  }
  function syncCancelExpensiveOffersByMeals() {
    if (!cancelExpensiveReduceRow || !cancelExpensiveReduceInput) return;
    var mealsPerWeek = getCurrentMealsPerWeek();
    var canReduce = mealsPerWeek === 0 || mealsPerWeek > 4;
    if (canReduce) {
      cancelExpensiveReduceInput.disabled = false;
      cancelExpensiveReduceRow.style.opacity = '';
      if (cancelExpensiveReduceTitle) cancelExpensiveReduceTitle.textContent = 'Reduce meals per week';
      if (cancelExpensiveReduceSub) cancelExpensiveReduceSub.textContent = 'Lower cost, stay subscribed';
    } else {
      cancelExpensiveReduceInput.checked = false;
      cancelExpensiveReduceInput.disabled = true;
      cancelExpensiveReduceRow.style.opacity = '0.6';
      if (_cancelExpensiveOffer === 'reduce') _cancelExpensiveOffer = '';
      if (cancelExpensiveReduceTitle) cancelExpensiveReduceTitle.textContent = 'Already on lowest meal pack';
      if (cancelExpensiveReduceSub) cancelExpensiveReduceSub.textContent = 'You are already on 4 meals/week. Try Pause instead.';
    }
    updateCancelExpensiveProceedBtn();
  }
  function updateCancelExpensiveProceedBtn() {
    if (!cancelExpensiveProceedBtn) return;
    if (!_cancelExpensiveOffer) {
      cancelExpensiveProceedBtn.disabled = true;
      cancelExpensiveProceedBtn.textContent = 'CONTINUE';
      return;
    }
    cancelExpensiveProceedBtn.disabled = false;
    if (_cancelExpensiveOffer === 'reduce') {
      cancelExpensiveProceedBtn.textContent = 'GO TO MEAL SELECTION';
      return;
    }
    if (_cancelExpensiveOffer === 'pause') {
      cancelExpensiveProceedBtn.textContent = 'GO TO PAUSE';
      return;
    }
    cancelExpensiveProceedBtn.textContent = 'PROCEED TO CANCEL';
  }
  function executeCancelExpensivePauseInstead() {
    var ps = document.getElementById('pauseRefundReasonSelect');
    var pd = document.getElementById('pauseRefundReasonDetail');
    if (ps) ps.value = 'too_expensive';
    if (pd) pd.value = 'too_expensive:pause|quantity_change:No';
    _pauseCallback = function(result) {
      _pauseCallback = null;
      if (result && result.ok && result.data && result.data.ok) {
        try { sessionStorage.removeItem('ufc_subs_cache'); } catch (e) {}
        window.location.href = window.location.pathname + window.location.search;
        return;
      }
      var msg = (result && result.data && (result.data.error || result.data.message))
        ? String(result.data.error || result.data.message)
        : 'Pause failed. Please try again.';
      alert(msg);
    };
    runPauseWithOptionalResumeDate('close', {
      withDateHtml: function() { return null; },
      indefiniteHtml: null
    });
  }
  function openCancelOptionalStep(reason, subreason, saveShown, saveAccepted) {
    _cancelOptionalMeta = {
      reason: reason || '',
      subreason: subreason || '',
      saveShown: saveShown || 'No',
      saveAccepted: saveAccepted || 'No',
    };
    setCancelSubTag('cancelOptionalSubreasonTag', _cancelOptionalMeta.subreason || 'subreason', 'subreason');
    if (cancelOptionalDetail) cancelOptionalDetail.value = '';
    hideAllCancelStep2Panels();
    if (cancelFlowStep3Optional) cancelFlowStep3Optional.style.display = '';
    if (cancelSurveyStep) cancelSurveyStep.style.display = 'none';
  }
  function backFromCancelOptionalStep() {
    hideAllCancelStep2Panels();
    if (_cancelOptionalMeta && _cancelOptionalMeta.reason === 'travel_or_move' && cancelFlowStep2Lifestyle) {
      if (cancelSurveyStep) cancelSurveyStep.style.display = 'none';
      cancelFlowStep2Lifestyle.style.display = '';
      return;
    }
    if (cancelSurveyStep) cancelSurveyStep.style.display = '';
  }
  function proceedCancelFromOptional(includeText) {
    var selectedCancel = overlay.querySelector('input[name="ufcManagedCancelReason"]:checked');
    if (!selectedCancel) return;
    var reasonCode = selectedCancel.value;
    var detail = '';
    if (includeText && cancelOptionalDetail) {
      detail = String(cancelOptionalDetail.value || '').trim().slice(0, 500);
    }
    var metaPrefix = 'meta:sub=' + (_cancelOptionalMeta.subreason || 'none')
      + '|save_shown=' + (_cancelOptionalMeta.saveShown || 'No')
      + '|save_accepted=' + (_cancelOptionalMeta.saveAccepted || 'No');
    var finalDetail = detail ? (metaPrefix + '|text=' + detail) : metaPrefix;
    window.__ufcPendingRefundReason = { code: reasonCode, detail: finalDetail.slice(0, 500) };
    if (!_cancelResolved && _cancelCallback) {
      _cancelResolved = true;
      try { _cancelCallback(true); } catch (e) {}
    }
    _cancelCallback = null;
    closeManagedOverlay(false);
  }
  function calcResumeDate(weeks) {
    var now = new Date();
    var day = now.getUTCDay();
    var daysUntilTue = (2 - day + 7) % 7;
    if (daysUntilTue === 0) daysUntilTue = 7;
    var nextTue = new Date(now);
    nextTue.setUTCDate(now.getUTCDate() + daysUntilTue + (weeks * 7));
    return nextTue;
  }
  function formatResumeDate(d) {
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    return months[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear();
  }
  function dateToLocalISO(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }
  function formatSlashDateFromISO(iso) {
    if (!iso || iso.indexOf('-') < 0) return '—';
    var p = iso.split('-');
    return p[0] + '/' + p[1] + '/' + p[2];
  }
  function formatSuccessResumeFromISO(iso) {
    var p = iso.split('-');
    if (p.length !== 3) return '—';
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }
  function pickPauseWeeksForResumeDate(isoStr) {
    var parts = isoStr.split('-');
    if (parts.length !== 3) return 2;
    var chosenStart = Date.UTC(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    var w;
    for (w = 1; w <= 8; w++) {
      var d = calcResumeDate(w);
      var dStart = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
      if (dStart >= chosenStart) return w;
    }
    return 8;
  }
  function closePauseDatePicker() {
    if (!pauseDatePickerOverlay) return;
    pauseDatePickerOverlay.classList.remove('is-open');
    _pauseDatePickerCallback = null;
  }
  function openPauseDatePicker(defaultIso, cb) {
    if (!pauseDatePickerOverlay || !pauseDatePickerInput) {
      if (cb) cb(dateToLocalISO(calcResumeDate(_pauseSelectedWeeks || 2)));
      return;
    }
    var minD = new Date();
    minD.setDate(minD.getDate() + 1);
    var minIso = dateToLocalISO(minD);
    var maxIso = dateToLocalISO(calcResumeDate(8));
    pauseDatePickerInput.min = minIso;
    pauseDatePickerInput.max = maxIso;
    var defIso = defaultIso || dateToLocalISO(calcResumeDate(_pauseSelectedWeeks || 2));
    if (defIso < minIso) defIso = minIso;
    if (defIso > maxIso) defIso = maxIso;
    pauseDatePickerInput.value = defIso;
    _pauseDatePickerCallback = cb || null;
    pauseDatePickerOverlay.classList.add('is-open');
  }
  function syncTravelDataTags() {
    var inp = pauseTravelResumeInput;
    var tag = document.getElementById('pauseTravelTagResume');
    if (!inp || !tag) return;
    var v = inp.value;
    tag.textContent = v ? ('resume_date: ' + formatSlashDateFromISO(v)) : 'resume_date: —';
  }
  function initPauseTravelStep() {
    var inp = pauseTravelResumeInput;
    if (!inp) return;
    var minD = new Date();
    minD.setDate(minD.getDate() + 1);
    inp.min = dateToLocalISO(minD);
    inp.max = dateToLocalISO(calcResumeDate(8));
    var def = dateToLocalISO(calcResumeDate(2));
    if (!inp.value || inp.value < inp.min) inp.value = def;
    if (inp.value > inp.max) inp.value = inp.max;
    syncTravelDataTags();
    inp.oninput = syncTravelDataTags;
  }
  function backFromPauseStep2() {
    if (pauseFlowStep1) pauseFlowStep1.style.display = '';
    if (pauseFlowStep2Wrap) pauseFlowStep2Wrap.style.display = 'none';
  }
  function syncTooMuchDataTag() {
    var el = document.getElementById('pauseTooMuchTagSub');
    if (!el) return;
    if (!_pauseTooMuchSub) el.textContent = 'subreason: —';
    else el.textContent = 'subreason: ' + _pauseTooMuchSub + (_pauseTooMuchQty ? ' | meals: ' + _pauseTooMuchQty : '');
  }
  function updateTooMuchConfirmBtn() {
    if (!pauseTooMuchConfirmBtn) return;
    if (!_pauseTooMuchSub) {
      pauseTooMuchConfirmBtn.disabled = true;
      pauseTooMuchConfirmBtn.textContent = 'CONFIRM PAUSE';
      return;
    }
    if (_pauseTooMuchSub === 'reduce') {
      pauseTooMuchConfirmBtn.textContent = 'GO TO MEAL SELECTION';
      pauseTooMuchConfirmBtn.disabled = false;
    } else {
      pauseTooMuchConfirmBtn.textContent = 'CONFIRM PAUSE';
      pauseTooMuchConfirmBtn.disabled = false;
    }
  }
  function initPauseTooMuchStep() {
    _pauseTooMuchSub = '';
    _pauseTooMuchQty = null;
    overlay.querySelectorAll('input[name="ufcPauseTooMuchSub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#managedPauseTooMuchList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    var qtyWrap = document.getElementById('pauseTooMuchQtyWrap');
    if (qtyWrap) { qtyWrap.classList.add('is-visible'); qtyWrap.setAttribute('aria-hidden', 'false'); }
    syncTooMuchDataTag();
    updateTooMuchConfirmBtn();
  }
  function hideAllPauseStep2Panels() {
    _pauseStep2PanelIds.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
  }
  function setBranchTag(tagId, sub, qty) {
    var el = document.getElementById(tagId);
    if (!el) return;
    if (!sub) el.textContent = 'subreason: —';
    else el.textContent = 'subreason: ' + sub + (qty ? ' | meals: ' + qty : '');
  }
  function resolvePauseMealSelectionUrl() {
    var url = window.__ufcEditMealsUrl ? String(window.__ufcEditMealsUrl).trim() : '';
    if (url) return url;
    return _pauseMealSelectionUrl;
  }
  function syncPauseMealSelectionLinks() {
    var url = resolvePauseMealSelectionUrl();
    overlay.querySelectorAll('.js-pause-meal-link').forEach(function(link) {
      link.setAttribute('href', url);
    });
  }
  function goToPauseMealSelection(sourceAction) {
    var url = resolvePauseMealSelectionUrl();
    var src = String(sourceAction || '').trim().toLowerCase();
    if (!src) src = 'pause';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('entryAction', src);
      window.location.href = u.toString();
      return;
    } catch (e) {}
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    window.location.href = url + sep + 'entryAction=' + encodeURIComponent(src);
  }
  function successResumeHtmlDefaultWeeks() {
    if (!(_pauseSelectedWeeks > 0)) {
      return '<strong>Resumes automatically:</strong> No auto-resume (indefinite pause)';
    }
    return '<strong>Resumes automatically:</strong> ' + formatResumeDate(calcResumeDate(_pauseSelectedWeeks));
  }
  function getIndefinitePauseResumeHtml() {
    return '<strong>Resumes automatically:</strong> No auto-resume (indefinite pause)';
  }
  function runPauseWithOptionalResumeDate(afterSuccessUi, opts) {
    var withDateHtml = opts && opts.withDateHtml;
    var indefiniteHtml = (opts && opts.indefiniteHtml !== undefined) ? opts.indefiniteHtml : getIndefinitePauseResumeHtml();
    if (!(_pauseSelectedWeeks > 0)) {
      runPauseApiRequest(afterSuccessUi, indefiniteHtml);
      return;
    }
    openPauseDatePicker(dateToLocalISO(calcResumeDate(_pauseSelectedWeeks)), function(iso) {
      _pauseSelectedWeeks = pickPauseWeeksForResumeDate(iso);
      var successHtml = withDateHtml ? withDateHtml(iso) : null;
      runPauseApiRequest(afterSuccessUi, successHtml);
    });
  }
  function initPauseScheduleStep() {
    _pauseScheduleSub = '';
    _pauseScheduleQty = null;
    overlay.querySelectorAll('input[name="ufcPauseScheduleSub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#managedPauseScheduleList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    var w = document.getElementById('pauseScheduleQtyWrap');
    if (w) { w.classList.add('is-visible'); w.setAttribute('aria-hidden', 'false'); }
    setBranchTag('pauseScheduleTagSub', '', null);
    var b = document.getElementById('pauseScheduleConfirmBtn');
    if (b) { b.disabled = true; b.textContent = 'CONFIRM'; }
  }
  function updateScheduleConfirmBtn() {
    var b = document.getElementById('pauseScheduleConfirmBtn');
    if (!b) return;
    if (!_pauseScheduleSub) { b.disabled = true; return; }
    if (_pauseScheduleSub === 'reduce') {
      b.disabled = false;
      b.textContent = 'GO TO MEAL SELECTION';
      return;
    }
    b.disabled = false;
    b.textContent = 'CONFIRM';
  }
  function initPauseExpensiveStep() {
    _pauseExpensiveSub = '';
    _pauseExpensiveQty = null;
    overlay.querySelectorAll('input[name="ufcPauseExpensiveSub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#managedPauseExpensiveList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    var w = document.getElementById('pauseExpensiveQtyWrap');
    if (w) { w.classList.add('is-visible'); w.setAttribute('aria-hidden', 'false'); }
    setBranchTag('pauseExpensiveTagSub', '', null);
    var b = document.getElementById('pauseExpensiveConfirmBtn');
    if (b) { b.disabled = true; b.textContent = 'CONFIRM'; }
  }
  function updateExpensiveConfirmBtn() {
    var b = document.getElementById('pauseExpensiveConfirmBtn');
    if (!b) return;
    if (!_pauseExpensiveSub) { b.disabled = true; return; }
    if (_pauseExpensiveSub === 'reduce') {
      b.disabled = false;
      b.textContent = 'GO TO MEAL SELECTION';
      return;
    }
    b.disabled = false;
    b.textContent = 'CONFIRM';
  }
  function initPauseFatigueStep() {
    _pauseFatigueSub = '';
    overlay.querySelectorAll('input[name="ufcPauseFatigueSub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#managedPauseFatigueList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    setBranchTag('pauseFatigueTagSub', '', null);
    var b = document.getElementById('pauseFatigueConfirmBtn');
    if (b) { b.disabled = true; b.textContent = 'CONTINUE & PAUSE'; }
  }
  function updateFatigueConfirmBtn() {
    var b = document.getElementById('pauseFatigueConfirmBtn');
    if (!b) return;
    b.disabled = !_pauseFatigueSub;
  }
  function initPauseDeliveryStep() {
    _pauseDeliverySub = '';
    overlay.querySelectorAll('input[name="ufcPauseDeliverySub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#managedPauseDeliveryList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    setBranchTag('pauseDeliveryTagSub', '', null);
    var b = document.getElementById('pauseDeliveryConfirmBtn');
    if (b) { b.disabled = true; b.textContent = 'PAUSE & FLAG ISSUE'; }
  }
  function updateDeliveryConfirmBtn() {
    var b = document.getElementById('pauseDeliveryConfirmBtn');
    if (!b) return;
    b.disabled = !_pauseDeliverySub;
  }
  function initPauseTryingStep() {
    _pauseTryingSub = '';
    overlay.querySelectorAll('input[name="ufcPauseTryingSub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#managedPauseTryingList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    setBranchTag('pauseTryingTagSub', '', null);
    var b = document.getElementById('pauseTryingConfirmBtn');
    if (b) { b.disabled = true; b.textContent = 'CONTINUE'; }
  }
  function updateTryingConfirmBtn() {
    var b = document.getElementById('pauseTryingConfirmBtn');
    if (!b) return;
    b.disabled = !_pauseTryingSub;
  }
  function updatePauseUI() {
    if (pillsWrap) {
      pillsWrap.querySelectorAll('.pause-modal__pill').forEach(function(p) {
        p.classList.toggle('is-selected', parseInt(p.getAttribute('data-weeks'), 10) === _pauseSelectedWeeks);
      });
    }
    if (resumeDateText) {
      if (_pauseSelectedWeeks > 0) {
        var rd = calcResumeDate(_pauseSelectedWeeks);
        resumeDateText.textContent = formatResumeDate(rd);
      } else {
        resumeDateText.textContent = 'No auto-resume (indefinite pause)';
      }
    }
    if (confirmBtn) confirmBtn.textContent = 'CONTINUE';
  }

  var managedSegment = overlay.querySelector('.managed-sub-segment');
  var _managedModeLock = null;
  function setManagedMode(mode) {
    var targetMode = mode === 'cancel' ? 'cancel' : 'pause';
    if (_managedModeLock && targetMode !== _managedModeLock) return;
    var isPause = targetMode === 'pause';
    if (segPause) segPause.style.display = isPause ? '' : 'none';
    if (segCancel) segCancel.style.display = isPause ? 'none' : '';
    if (segPause) { segPause.classList.toggle('is-active', isPause); segPause.setAttribute('aria-selected', isPause ? 'true' : 'false'); }
    if (segCancel) { segCancel.classList.toggle('is-active', !isPause); segCancel.setAttribute('aria-selected', !isPause ? 'true' : 'false'); }
    panelPause.style.display = isPause ? 'block' : 'none';
    panelCancel.style.display = isPause ? 'none' : 'block';
    if (isPause) resetPauseFlow();
  }

  function resetPauseFlow() {
    if (pauseFlowStep1) pauseFlowStep1.style.display = '';
    if (pauseFlowStep2Wrap) pauseFlowStep2Wrap.style.display = 'none';
    if (pauseFlowStep3Success) pauseFlowStep3Success.style.display = 'none';
    hideAllPauseStep2Panels();
    _pauseTooMuchSub = '';
    _pauseTooMuchQty = null;
    overlay.querySelectorAll('input[name="ufcPauseTooMuchSub"]').forEach(function(r) { r.checked = false; });
    var qtyWrapR = document.getElementById('pauseTooMuchQtyWrap');
    if (qtyWrapR) { qtyWrapR.classList.remove('is-visible'); qtyWrapR.setAttribute('aria-hidden', 'true'); }
    var gridR = document.getElementById('pauseTooMuchQtyGrid');
    if (gridR) gridR.querySelectorAll('.pause-modal__pill').forEach(function(p) { p.classList.remove('is-selected'); });
    var tagSub = document.getElementById('pauseTooMuchTagSub');
    if (tagSub) tagSub.textContent = 'subreason: —';
    if (pauseTooMuchConfirmBtn) { pauseTooMuchConfirmBtn.disabled = true; pauseTooMuchConfirmBtn.textContent = 'CONTINUE'; }
    initPauseScheduleStep();
    initPauseExpensiveStep();
    initPauseFatigueStep();
    initPauseDeliveryStep();
    initPauseTryingStep();
    var srb = document.getElementById('pauseSuccessResumeBox');
    if (srb) srb.innerHTML = '<strong>Resumes automatically:</strong> —';
    _lastPauseResult = null;
    overlay.querySelectorAll('input[name="ufcManagedPauseReason"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#managedPauseReasonList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    var ps = document.getElementById('pauseRefundReasonSelect');
    var pd = document.getElementById('pauseRefundReasonDetail');
    if (ps) ps.value = '';
    if (pd) { pd.value = ''; pd.style.display = 'none'; }
    if (pauseOtherDetailLabel) pauseOtherDetailLabel.style.display = 'none';
    if (pauseFlowContinue) pauseFlowContinue.disabled = true;
    if (confirmBtn) { confirmBtn.disabled = false; }
    if (pauseTravelConfirmBtn) { pauseTravelConfirmBtn.disabled = false; pauseTravelConfirmBtn.textContent = 'PAUSE UNTIL THEN'; }
    if (pauseTravelResumeInput) pauseTravelResumeInput.value = '';
    syncPauseMealSelectionLinks();
    syncTravelDataTags();
    updatePauseUI();
  }

  function resetCancelFlow() {
    if (cancelSurveyStep) cancelSurveyStep.style.display = '';
    hideAllCancelStep2Panels();
    if (cancelFinalStep) cancelFinalStep.style.display = 'none';
    overlay.querySelectorAll('input[name="ufcManagedCancelReason"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#managedCancelReasonList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    _cancelExpensiveOffer = '';
    _cancelDeliverySub = '';
    _cancelQualitySub = '';
    _cancelFatigueSub = '';
    _cancelLifestyleOffer = '';
    _cancelOptionalMeta = { reason: '', subreason: '', saveShown: 'N', saveAccepted: 'N' };
    overlay.querySelectorAll('input[name="ufcCancelExpensiveOffer"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#cancelExpensiveOfferList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    overlay.querySelectorAll('input[name="ufcCancelDeliverySub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#cancelDeliveryList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    overlay.querySelectorAll('input[name="ufcCancelQualitySub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#cancelQualityList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    overlay.querySelectorAll('input[name="ufcCancelFatigueSub"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#cancelFatigueList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    overlay.querySelectorAll('input[name="ufcCancelLifestyleOffer"]').forEach(function(r) { r.checked = false; });
    overlay.querySelectorAll('#cancelLifestyleList .managed-flow-row').forEach(function(row) { row.classList.remove('is-selected'); });
    if (cancelExpensiveProceedBtn) {
      cancelExpensiveProceedBtn.disabled = true;
      cancelExpensiveProceedBtn.textContent = 'CONTINUE';
    }
    if (cancelExpensiveReduceInput) cancelExpensiveReduceInput.disabled = false;
    if (cancelExpensiveReduceRow) cancelExpensiveReduceRow.style.opacity = '';
    if (cancelExpensiveReduceTitle) cancelExpensiveReduceTitle.textContent = 'Reduce meals per week';
    if (cancelExpensiveReduceSub) cancelExpensiveReduceSub.textContent = 'Lower cost, stay subscribed';
    if (cancelDeliveryProceedBtn) cancelDeliveryProceedBtn.disabled = true;
    if (cancelQualityProceedBtn) cancelQualityProceedBtn.disabled = true;
    if (cancelFatigueProceedBtn) cancelFatigueProceedBtn.disabled = true;
    if (cancelLifestyleProceedBtn) cancelLifestyleProceedBtn.disabled = true;
    setCancelSubTag('cancelDeliveryTagSub', 'delivery_subreason', 'delivery_subreason');
    setCancelSubTag('cancelQualityTagSub', 'quality_subreason', 'quality_subreason');
    setCancelSubTag('cancelFatigueTagSub', 'subreason (product signal)', 'subreason (product signal)');
    setCancelSubTag('cancelLifestyleAcceptedTag', 'save_accepted: pending', 'save_accepted: pending');
    setCancelSubTag('cancelOptionalSubreasonTag', 'subreason', 'subreason');
    if (cancelSurveyContinue) { cancelSurveyContinue.disabled = true; }
    if (cancelRefundDetail) { cancelRefundDetail.value = ''; cancelRefundDetail.style.display = 'none'; }
    if (cancelOptionalDetail) cancelOptionalDetail.value = '';
    if (cancelFinalOtherLabel) cancelFinalOtherLabel.style.display = 'none';
    if (finalBtn) { finalBtn.disabled = false; finalBtn.textContent = 'Yes, Cancel My Subscription'; }
    window.__ufcPendingRefundReason = null;
  }

  function syncCancelRowSelected() {
    overlay.querySelectorAll('#managedCancelReasonList .managed-flow-row').forEach(function(row) {
      var inp = row.querySelector('input[type="radio"]');
      row.classList.toggle('is-selected', inp && inp.checked);
    });
  }

  function syncPauseRowSelected() {
    overlay.querySelectorAll('#managedPauseReasonList .managed-flow-row').forEach(function(row) {
      var inp = row.querySelector('input[type="radio"]');
      row.classList.toggle('is-selected', inp && inp.checked);
    });
  }

  function syncPauseSelectFromRadio() {
    var sel = overlay.querySelector('input[name="ufcManagedPauseReason"]:checked');
    var ps = document.getElementById('pauseRefundReasonSelect');
    if (ps && sel) ps.value = sel.value;
  }

  overlay.querySelectorAll('input[name="ufcManagedCancelReason"]').forEach(function(r) {
    r.addEventListener('change', function() {
      syncCancelRowSelected();
      if (cancelSurveyContinue) cancelSurveyContinue.disabled = !overlay.querySelector('input[name="ufcManagedCancelReason"]:checked');
    });
  });
  overlay.querySelectorAll('#managedCancelReasonList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });

  overlay.querySelectorAll('input[name="ufcManagedPauseReason"]').forEach(function(r) {
    r.addEventListener('change', function() {
      syncPauseRowSelected();
      syncPauseSelectFromRadio();
      if (pauseFlowContinue) pauseFlowContinue.disabled = !overlay.querySelector('input[name="ufcManagedPauseReason"]:checked');
    });
  });
  overlay.querySelectorAll('#managedPauseReasonList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });

  if (pillsWrap) {
    pillsWrap.addEventListener('click', function(e) {
      var pill = e.target.closest('.pause-modal__pill');
      if (!pill) return;
      var weeks = parseInt(pill.getAttribute('data-weeks'), 10);
      if (isNaN(weeks) || weeks < 0 || weeks > 8) return;
      _pauseSelectedWeeks = (_pauseSelectedWeeks === weeks) ? 0 : weeks;
      updatePauseUI();
    });
  }

  function closeManagedOverlay(cancelNotify) {
    overlay.classList.remove('is-open');
    closePauseDatePicker();
    document.body.style.overflow = '';
    _managedModeLock = null;
    if (managedSegment) managedSegment.style.display = '';
    if (confirmBtn) { confirmBtn.disabled = false; }
    resetCancelFlow();
    setManagedMode('pause');
    if (cancelNotify && !_cancelResolved && _cancelCallback) {
      _cancelResolved = true;
      try { _cancelCallback(false); } catch (e) {}
    }
    _cancelCallback = null;
  }

  if (closeTop) closeTop.addEventListener('click', function() {
    var notify = !!_cancelCallback && !_cancelResolved;
    closeManagedOverlay(notify);
  });
  if (pauseDatePickerClose) pauseDatePickerClose.addEventListener('click', closePauseDatePicker);
  if (pauseDatePickerCancel) pauseDatePickerCancel.addEventListener('click', closePauseDatePicker);
  if (pauseDatePickerOverlay) {
    pauseDatePickerOverlay.addEventListener('click', function(e) {
      if (e.target === pauseDatePickerOverlay) closePauseDatePicker();
    });
  }
  if (pauseDatePickerConfirm) {
    pauseDatePickerConfirm.addEventListener('click', function() {
      if (!pauseDatePickerInput || !pauseDatePickerInput.value) {
        alert('Please choose a resume date.');
        return;
      }
      if (pauseDatePickerInput.min && pauseDatePickerInput.value < pauseDatePickerInput.min) {
        alert('Resume date must be at least 1 day ahead.');
        return;
      }
      if (pauseDatePickerInput.max && pauseDatePickerInput.value > pauseDatePickerInput.max) {
        alert('Resume date is too far out for this pause flow.');
        return;
      }
      var cb = _pauseDatePickerCallback;
      var picked = pauseDatePickerInput.value;
      closePauseDatePicker();
      if (cb) cb(picked);
    });
  }
  if (keepBtn) keepBtn.addEventListener('click', function() {
    closeManagedOverlay(!!_cancelCallback && !_cancelResolved);
  });
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) {
      var notify = !!_cancelCallback && !_cancelResolved;
      closeManagedOverlay(notify);
    }
  });

  if (segPause) segPause.addEventListener('click', function() { setManagedMode('pause'); });
  if (segCancel) segCancel.addEventListener('click', function() { setManagedMode('cancel'); resetCancelFlow(); });

  if (pauseFlowContinue) {
    pauseFlowContinue.addEventListener('click', function() {
      if (!overlay.querySelector('input[name="ufcManagedPauseReason"]:checked')) return;
      syncPauseSelectFromRadio();
      var sel = overlay.querySelector('input[name="ufcManagedPauseReason"]:checked');
      var isOther = sel && sel.value === 'other';
      var pd = document.getElementById('pauseRefundReasonDetail');
      if (pauseOtherDetailLabel) pauseOtherDetailLabel.style.display = isOther ? 'block' : 'none';
      if (pd) { pd.style.display = isOther ? 'block' : 'none'; if (!isOther) pd.value = ''; }
      if (pauseFlowStep1) pauseFlowStep1.style.display = 'none';
      if (pauseFlowStep2Wrap) pauseFlowStep2Wrap.style.display = '';
      hideAllPauseStep2Panels();
      var v = sel ? sel.value : '';
      if (v === 'travel_or_move') {
        if (pauseFlowStep2Travel) pauseFlowStep2Travel.style.display = '';
        initPauseTravelStep();
      } else if (v === 'not_eating_enough') {
        if (pauseFlowStep2TooMuch) pauseFlowStep2TooMuch.style.display = '';
        initPauseTooMuchStep();
      } else if (v === 'prefer_pause') {
        if (pauseFlowStep2Schedule) pauseFlowStep2Schedule.style.display = '';
        initPauseScheduleStep();
      } else if (v === 'too_expensive') {
        if (pauseFlowStep2Expensive) pauseFlowStep2Expensive.style.display = '';
        initPauseExpensiveStep();
      } else if (v === 'quality') {
        if (pauseFlowStep2Fatigue) pauseFlowStep2Fatigue.style.display = '';
        initPauseFatigueStep();
      } else if (v === 'delivery_issue') {
        if (pauseFlowStep2Delivery) pauseFlowStep2Delivery.style.display = '';
        initPauseDeliveryStep();
      } else if (v === 'trying_competitor') {
        if (pauseFlowStep2Trying) pauseFlowStep2Trying.style.display = '';
        initPauseTryingStep();
      } else {
        if (pauseFlowStep2Standard) pauseFlowStep2Standard.style.display = '';
        updatePauseUI();
      }
    });
  }
  if (pauseFlowBack) pauseFlowBack.addEventListener('click', backFromPauseStep2);
  if (pauseTravelBack) pauseTravelBack.addEventListener('click', backFromPauseStep2);
  if (pauseTooMuchBack) pauseTooMuchBack.addEventListener('click', backFromPauseStep2);
  overlay.querySelectorAll('input[name="ufcPauseTooMuchSub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _pauseTooMuchSub = r.value;
      overlay.querySelectorAll('#managedPauseTooMuchList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      syncTooMuchDataTag();
      updateTooMuchConfirmBtn();
    });
  });
  overlay.querySelectorAll('#managedPauseTooMuchList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  overlay.querySelectorAll('input[name="ufcPauseScheduleSub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _pauseScheduleSub = r.value;
      overlay.querySelectorAll('#managedPauseScheduleList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setBranchTag('pauseScheduleTagSub', _pauseScheduleSub, _pauseScheduleQty);
      updateScheduleConfirmBtn();
    });
  });
  overlay.querySelectorAll('#managedPauseScheduleList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  overlay.querySelectorAll('input[name="ufcPauseExpensiveSub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _pauseExpensiveSub = r.value;
      overlay.querySelectorAll('#managedPauseExpensiveList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setBranchTag('pauseExpensiveTagSub', _pauseExpensiveSub, _pauseExpensiveQty);
      updateExpensiveConfirmBtn();
    });
  });
  overlay.querySelectorAll('#managedPauseExpensiveList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  overlay.querySelectorAll('input[name="ufcPauseFatigueSub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _pauseFatigueSub = r.value;
      overlay.querySelectorAll('#managedPauseFatigueList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setBranchTag('pauseFatigueTagSub', _pauseFatigueSub, null);
      updateFatigueConfirmBtn();
    });
  });
  overlay.querySelectorAll('#managedPauseFatigueList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  overlay.querySelectorAll('input[name="ufcPauseDeliverySub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _pauseDeliverySub = r.value;
      overlay.querySelectorAll('#managedPauseDeliveryList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setBranchTag('pauseDeliveryTagSub', _pauseDeliverySub, null);
      updateDeliveryConfirmBtn();
    });
  });
  overlay.querySelectorAll('#managedPauseDeliveryList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  overlay.querySelectorAll('input[name="ufcPauseTryingSub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _pauseTryingSub = r.value;
      overlay.querySelectorAll('#managedPauseTryingList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setBranchTag('pauseTryingTagSub', _pauseTryingSub, null);
      updateTryingConfirmBtn();
    });
  });
  overlay.querySelectorAll('#managedPauseTryingList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  overlay.querySelectorAll('.js-pause-branch-back').forEach(function(btn) {
    btn.addEventListener('click', backFromPauseStep2);
  });
  if (pauseFlowKeep1) {
    pauseFlowKeep1.addEventListener('click', function() {
      closeManagedOverlay(!!_cancelCallback && !_cancelResolved);
    });
  }

  if (cancelSurveyContinue) {
    cancelSurveyContinue.addEventListener('click', function() {
      var sel = overlay.querySelector('input[name="ufcManagedCancelReason"]:checked');
      if (!sel) return;
      var row = sel.closest('[data-reason-label]');
      var label = row ? row.getAttribute('data-reason-label') : '';
      if (cancelFinalReasonSummary) cancelFinalReasonSummary.textContent = 'Reason: ' + (label || sel.value);
      if (sel.value === 'too_expensive') {
        if (cancelSurveyStep) cancelSurveyStep.style.display = 'none';
        if (cancelFlowStep2Expensive) cancelFlowStep2Expensive.style.display = '';
        syncCancelExpensiveOffersByMeals();
        return;
      }
      if (sel.value === 'delivery_issue') {
        if (cancelSurveyStep) cancelSurveyStep.style.display = 'none';
        if (cancelFlowStep2Delivery) cancelFlowStep2Delivery.style.display = '';
        return;
      }
      if (sel.value === 'quality') {
        if (cancelSurveyStep) cancelSurveyStep.style.display = 'none';
        if (cancelFlowStep2Quality) cancelFlowStep2Quality.style.display = '';
        return;
      }
      if (sel.value === 'not_eating_enough') {
        if (cancelSurveyStep) cancelSurveyStep.style.display = 'none';
        if (cancelFlowStep2Fatigue) cancelFlowStep2Fatigue.style.display = '';
        return;
      }
      if (sel.value === 'travel_or_move') {
        if (cancelSurveyStep) cancelSurveyStep.style.display = 'none';
        if (cancelFlowStep2Lifestyle) cancelFlowStep2Lifestyle.style.display = '';
        return;
      }
      if (sel.value === 'prefer_pause') {
        openCancelOptionalStep('prefer_pause', 'paused_never_came_back', 'Yes', 'No');
        return;
      }
      if (sel.value === 'trying_competitor') {
        openCancelOptionalStep('trying_competitor', 'switching_service', 'Yes', 'No');
        return;
      }
      if (sel.value === 'other') {
        openCancelOptionalStep('other', 'other_reason', 'No', 'No');
        return;
      }
      var isOther = sel.value === 'other';
      if (cancelRefundDetail) {
        cancelRefundDetail.style.display = isOther ? 'block' : 'none';
        if (!isOther) cancelRefundDetail.value = '';
      }
      if (cancelFinalOtherLabel) cancelFinalOtherLabel.style.display = isOther ? 'block' : 'none';
      if (cancelSurveyStep) cancelSurveyStep.style.display = 'none';
      if (cancelFinalStep) cancelFinalStep.style.display = '';
    });
  }
  if (cancelModalBack) {
    cancelModalBack.addEventListener('click', function() {
      if (cancelFinalStep && cancelFinalStep.style.display !== 'none') {
        var selectedCancel = overlay.querySelector('input[name="ufcManagedCancelReason"]:checked');
        hideAllCancelStep2Panels();
        if (selectedCancel && selectedCancel.value === 'too_expensive' && cancelFlowStep2Expensive) {
          cancelFlowStep2Expensive.style.display = '';
          cancelSurveyStep.style.display = 'none';
        } else if (selectedCancel && selectedCancel.value === 'delivery_issue' && cancelFlowStep2Delivery) {
          cancelFlowStep2Delivery.style.display = '';
          cancelSurveyStep.style.display = 'none';
        } else if (selectedCancel && selectedCancel.value === 'quality' && cancelFlowStep2Quality) {
          cancelFlowStep2Quality.style.display = '';
          cancelSurveyStep.style.display = 'none';
        } else if (selectedCancel && selectedCancel.value === 'not_eating_enough' && cancelFlowStep2Fatigue) {
          cancelFlowStep2Fatigue.style.display = '';
          cancelSurveyStep.style.display = 'none';
        } else if (selectedCancel && selectedCancel.value === 'travel_or_move' && cancelFlowStep2Lifestyle) {
          cancelFlowStep2Lifestyle.style.display = '';
          cancelSurveyStep.style.display = 'none';
        } else if (selectedCancel && (selectedCancel.value === 'prefer_pause' || selectedCancel.value === 'trying_competitor' || selectedCancel.value === 'other') && cancelFlowStep3Optional) {
          cancelFlowStep3Optional.style.display = '';
          cancelSurveyStep.style.display = 'none';
        } else if (cancelSurveyStep) {
          cancelSurveyStep.style.display = '';
        }
        if (cancelFinalStep) cancelFinalStep.style.display = 'none';
      }
    });
  }

  overlay.querySelectorAll('input[name="ufcCancelExpensiveOffer"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _cancelExpensiveOffer = r.value || '';
      overlay.querySelectorAll('#cancelExpensiveOfferList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      updateCancelExpensiveProceedBtn();
    });
  });
  overlay.querySelectorAll('#cancelExpensiveOfferList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  overlay.querySelectorAll('.js-cancel-expensive-back').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (cancelFlowStep2Expensive) cancelFlowStep2Expensive.style.display = 'none';
      if (cancelSurveyStep) cancelSurveyStep.style.display = '';
    });
  });
  if (cancelExpensiveProceedBtn) {
    cancelExpensiveProceedBtn.addEventListener('click', function() {
      if (!_cancelExpensiveOffer) return;
      if (_cancelExpensiveOffer === 'reduce') {
        goToPauseMealSelection('cancel');
        return;
      }
      if (_cancelExpensiveOffer === 'pause') {
        executeCancelExpensivePauseInstead();
        return;
      }
      if (cancelRefundDetail) cancelRefundDetail.value = ('too_expensive_offer:' + _cancelExpensiveOffer).slice(0, 500);
      if (cancelFinalReasonSummary) {
        cancelFinalReasonSummary.textContent = 'Reason: Too expensive (offer: ' + _cancelExpensiveOffer + ')';
      }
      if (cancelRefundDetail) cancelRefundDetail.style.display = 'none';
      if (cancelFinalOtherLabel) cancelFinalOtherLabel.style.display = 'none';
      if (cancelFlowStep2Expensive) cancelFlowStep2Expensive.style.display = 'none';
      if (cancelFinalStep) cancelFinalStep.style.display = '';
    });
  }

  overlay.querySelectorAll('input[name="ufcCancelDeliverySub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _cancelDeliverySub = r.value || '';
      overlay.querySelectorAll('#cancelDeliveryList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setCancelSubTag('cancelDeliveryTagSub', _cancelDeliverySub, 'delivery_subreason');
      if (cancelDeliveryProceedBtn) cancelDeliveryProceedBtn.disabled = !_cancelDeliverySub;
    });
  });
  overlay.querySelectorAll('#cancelDeliveryList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  if (cancelDeliveryProceedBtn) {
    cancelDeliveryProceedBtn.addEventListener('click', function() {
      if (!_cancelDeliverySub) return;
      if (cancelRefundDetail) cancelRefundDetail.value = ('delivery_issue:' + _cancelDeliverySub).slice(0, 500);
      if (cancelFinalReasonSummary) cancelFinalReasonSummary.textContent = 'Reason: Delivery issues (' + _cancelDeliverySub + ')';
      if (cancelFinalOtherLabel) cancelFinalOtherLabel.style.display = 'none';
      if (cancelRefundDetail) cancelRefundDetail.style.display = 'none';
      if (cancelFlowStep2Delivery) cancelFlowStep2Delivery.style.display = 'none';
      if (cancelFinalStep) cancelFinalStep.style.display = '';
    });
  }

  overlay.querySelectorAll('input[name="ufcCancelQualitySub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _cancelQualitySub = r.value || '';
      overlay.querySelectorAll('#cancelQualityList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setCancelSubTag('cancelQualityTagSub', _cancelQualitySub, 'quality_subreason');
      if (cancelQualityProceedBtn) cancelQualityProceedBtn.disabled = !_cancelQualitySub;
    });
  });
  overlay.querySelectorAll('#cancelQualityList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  if (cancelQualityProceedBtn) {
    cancelQualityProceedBtn.addEventListener('click', function() {
      if (!_cancelQualitySub) return;
      if (cancelRefundDetail) cancelRefundDetail.value = ('quality_expectations:' + _cancelQualitySub).slice(0, 500);
      if (cancelFinalReasonSummary) cancelFinalReasonSummary.textContent = 'Reason: Didn\'t meet expectations (' + _cancelQualitySub + ')';
      if (cancelFinalOtherLabel) cancelFinalOtherLabel.style.display = 'none';
      if (cancelRefundDetail) cancelRefundDetail.style.display = 'none';
      if (cancelFlowStep2Quality) cancelFlowStep2Quality.style.display = 'none';
      if (cancelFinalStep) cancelFinalStep.style.display = '';
    });
  }

  overlay.querySelectorAll('input[name="ufcCancelFatigueSub"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _cancelFatigueSub = r.value || '';
      overlay.querySelectorAll('#cancelFatigueList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setCancelSubTag('cancelFatigueTagSub', _cancelFatigueSub, 'subreason (product signal)');
      if (cancelFatigueProceedBtn) cancelFatigueProceedBtn.disabled = !_cancelFatigueSub;
    });
  });
  overlay.querySelectorAll('#cancelFatigueList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  if (cancelFatigueProceedBtn) {
    cancelFatigueProceedBtn.addEventListener('click', function() {
      if (!_cancelFatigueSub) return;
      if (cancelRefundDetail) cancelRefundDetail.value = ('menu_fatigue:' + _cancelFatigueSub).slice(0, 500);
      if (cancelFinalReasonSummary) cancelFinalReasonSummary.textContent = 'Reason: Menu fatigue (' + _cancelFatigueSub + ')';
      if (cancelFinalOtherLabel) cancelFinalOtherLabel.style.display = 'none';
      if (cancelRefundDetail) cancelRefundDetail.style.display = 'none';
      if (cancelFlowStep2Fatigue) cancelFlowStep2Fatigue.style.display = 'none';
      if (cancelFinalStep) cancelFinalStep.style.display = '';
    });
  }
  overlay.querySelectorAll('input[name="ufcCancelLifestyleOffer"]').forEach(function(r) {
    r.addEventListener('change', function() {
      _cancelLifestyleOffer = r.value || '';
      overlay.querySelectorAll('#cancelLifestyleList .managed-flow-row').forEach(function(row) {
        var inp = row.querySelector('input[type="radio"]');
        row.classList.toggle('is-selected', inp && inp.checked);
      });
      setCancelSubTag('cancelLifestyleAcceptedTag', _cancelLifestyleOffer === 'pause_instead' ? 'save_accepted: Yes' : (_cancelLifestyleOffer ? 'save_accepted: No' : 'save_accepted: pending'), 'save_accepted: pending');
      if (cancelLifestyleProceedBtn) cancelLifestyleProceedBtn.disabled = !_cancelLifestyleOffer;
    });
  });
  overlay.querySelectorAll('#cancelLifestyleList .managed-flow-row').forEach(function(row) {
    row.addEventListener('click', function(e) {
      if (e.target.tagName === 'INPUT') return;
      var inp = row.querySelector('input[type="radio"]');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  if (cancelLifestyleProceedBtn) {
    cancelLifestyleProceedBtn.addEventListener('click', function() {
      if (!_cancelLifestyleOffer) return;
      if (_cancelLifestyleOffer === 'pause_instead') {
        hideAllCancelStep2Panels();
        if (cancelSurveyStep) cancelSurveyStep.style.display = '';
        setManagedMode('pause');
        resetPauseFlow();
        return;
      }
      openCancelOptionalStep('travel_or_move', 'lifestyle_change_cancel', 'Yes', 'No');
    });
  }
  if (cancelOptionalSubmitBtn) {
    cancelOptionalSubmitBtn.addEventListener('click', function() { proceedCancelFromOptional(true); });
  }
  if (cancelOptionalSkipBtn) {
    cancelOptionalSkipBtn.addEventListener('click', function() { proceedCancelFromOptional(false); });
  }
  if (cancelOptionalBack) {
    cancelOptionalBack.addEventListener('click', backFromCancelOptionalStep);
  }
  overlay.querySelectorAll('.js-cancel-branch-back').forEach(function(btn) {
    btn.addEventListener('click', function() {
      hideAllCancelStep2Panels();
      if (cancelSurveyStep) cancelSurveyStep.style.display = '';
    });
  });
  if (finalBtn) {
    finalBtn.addEventListener('click', function() {
      var sel = overlay.querySelector('input[name="ufcManagedCancelReason"]:checked');
      if (!sel) {
        alert('Please select a reason.');
        return;
      }
      var det = cancelRefundDetail ? String(cancelRefundDetail.value || '').trim() : '';
      if (sel.value === 'other' && !det) {
        alert('Please add a short detail for “Other”.');
        return;
      }
      window.__ufcPendingRefundReason = { code: sel.value, detail: det.slice(0, 500) };
      finalBtn.disabled = true;
      finalBtn.textContent = 'Cancelling...';
      if (!_cancelResolved && _cancelCallback) {
        _cancelResolved = true;
        try { _cancelCallback(true); } catch (e) {}
      }
      _cancelCallback = null;
      closeManagedOverlay(false);
    });
  }

  function runPauseApiRequest(afterSuccessUi, resumeLineHtml) {
    var ps = document.getElementById('pauseRefundReasonSelect');
    var pd = document.getElementById('pauseRefundReasonDetail');
    if (!ps || !ps.value) {
      alert('Please select a reason for pausing.');
      return;
    }
    if (ps.value === 'other' && pd && !String(pd.value || '').trim()) {
      alert('Please add a short detail for “Other”.');
      return;
    }
    var screenBtn = null;
    var screenBtnDefault = '';
    var pauseScheduleConfirmBtnEl = document.getElementById('pauseScheduleConfirmBtn');
    var pauseExpensiveConfirmBtnEl = document.getElementById('pauseExpensiveConfirmBtn');
    var pauseFatigueConfirmBtnEl = document.getElementById('pauseFatigueConfirmBtn');
    var pauseDeliveryConfirmBtnEl = document.getElementById('pauseDeliveryConfirmBtn');
    var pauseTryingConfirmBtnEl = document.getElementById('pauseTryingConfirmBtn');
    if (afterSuccessUi === 'successScreen') {
      if (ps.value === 'travel_or_move' && pauseTravelConfirmBtn) {
        screenBtn = pauseTravelConfirmBtn;
        screenBtnDefault = 'PAUSE UNTIL THEN';
        screenBtn.disabled = true;
        screenBtn.textContent = 'PAUSING...';
      } else if (ps.value === 'not_eating_enough' && pauseTooMuchConfirmBtn) {
        screenBtn = pauseTooMuchConfirmBtn;
        screenBtnDefault = pauseTooMuchConfirmBtn.textContent;
        screenBtn.disabled = true;
        screenBtn.textContent = 'PAUSING...';
      } else if (ps.value === 'prefer_pause' && pauseScheduleConfirmBtnEl) {
        screenBtn = pauseScheduleConfirmBtnEl;
        screenBtnDefault = screenBtn.textContent;
        screenBtn.disabled = true;
        screenBtn.textContent = 'PAUSING...';
      } else if (ps.value === 'too_expensive' && pauseExpensiveConfirmBtnEl) {
        screenBtn = pauseExpensiveConfirmBtnEl;
        screenBtnDefault = screenBtn.textContent;
        screenBtn.disabled = true;
        screenBtn.textContent = 'PAUSING...';
      } else if (ps.value === 'quality' && pauseFatigueConfirmBtnEl) {
        screenBtn = pauseFatigueConfirmBtnEl;
        screenBtnDefault = screenBtn.textContent;
        screenBtn.disabled = true;
        screenBtn.textContent = 'PAUSING...';
      } else if (ps.value === 'delivery_issue' && pauseDeliveryConfirmBtnEl) {
        screenBtn = pauseDeliveryConfirmBtnEl;
        screenBtnDefault = screenBtn.textContent;
        screenBtn.disabled = true;
        screenBtn.textContent = 'PAUSING...';
      } else if (ps.value === 'trying_competitor' && pauseTryingConfirmBtnEl) {
        screenBtn = pauseTryingConfirmBtnEl;
        screenBtnDefault = screenBtn.textContent;
        screenBtn.disabled = true;
        screenBtn.textContent = 'PAUSING...';
      } else if (ps.value === 'other' && confirmBtn) {
        screenBtn = confirmBtn;
        screenBtnDefault = '';
        screenBtn.disabled = true;
        screenBtn.textContent = 'Pausing...';
      }
    } else if (confirmBtn) {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Pausing...';
    }
    function restorePauseScreenBtn() {
      if (!screenBtn) return;
      screenBtn.disabled = false;
      if (screenBtn === pauseTooMuchConfirmBtn) updateTooMuchConfirmBtn();
      else if (screenBtn === confirmBtn) updatePauseUI();
      else if (screenBtn === pauseScheduleConfirmBtnEl) updateScheduleConfirmBtn();
      else if (screenBtn === pauseExpensiveConfirmBtnEl) updateExpensiveConfirmBtn();
      else if (screenBtn === pauseFatigueConfirmBtnEl) updateFatigueConfirmBtn();
      else if (screenBtn === pauseDeliveryConfirmBtnEl) updateDeliveryConfirmBtn();
      else screenBtn.textContent = screenBtnDefault;
    }
    function restoreMainConfirmIfNeeded() {
      if (!screenBtn && confirmBtn) { confirmBtn.disabled = false; updatePauseUI(); }
      else if (screenBtn === confirmBtn) { confirmBtn.disabled = false; updatePauseUI(); }
    }
    fetchJsonWithPathFallback([
      '/apps/ufc-ignite/manage-subscription',
      '/apps/ufc-ignite/signup-and-invite/manage-subscription',
    ], {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'pause',
        contractId: _pauseContractId,
        customerEmail: _pauseCustomerEmail,
        pauseWeeks: _pauseSelectedWeeks,
        refundReasonCode: ps.value,
        refundReasonDetail: pd ? String(pd.value || '').trim().slice(0, 500) : ''
      })
    }, 60000)
      .then(function(result) {
        if (result.ok && result.data && result.data.ok && afterSuccessUi === 'successScreen') {
          _lastPauseResult = result;
          if (pauseFlowStep1) pauseFlowStep1.style.display = 'none';
          if (pauseFlowStep2Wrap) pauseFlowStep2Wrap.style.display = 'none';
          if (pauseFlowStep3Success) pauseFlowStep3Success.style.display = 'block';
          var resumeBox = document.getElementById('pauseSuccessResumeBox');
          if (resumeBox && resumeLineHtml) resumeBox.innerHTML = resumeLineHtml;
          restorePauseScreenBtn();
        } else if (result.ok && result.data && result.data.ok) {
          closeManagedOverlay(false);
          if (_pauseCallback) _pauseCallback(result);
        } else {
          restorePauseScreenBtn();
          restoreMainConfirmIfNeeded();
          var msg = (result.data && (result.data.error || result.data.message)) ? String(result.data.error || result.data.message) : 'Pause failed. Please try again.';
          alert(msg);
        }
      })
      .catch(function(err) {
        restorePauseScreenBtn();
        restoreMainConfirmIfNeeded();
        alert(err && err.message ? err.message : 'Network error.');
      });
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function() {
      var ps = document.getElementById('pauseRefundReasonSelect');
      if (!ps || !ps.value) {
        alert('Please select a reason for pausing.');
        return;
      }
      if (ps.value === 'other') {
        var pd = document.getElementById('pauseRefundReasonDetail');
        if (!pd || !String(pd.value || '').trim()) {
          alert('Please add a short detail for “Other”.');
          return;
        }
        runPauseWithOptionalResumeDate('successScreen', {
          withDateHtml: function(iso) { return '<strong>Resumes automatically:</strong> ' + formatSuccessResumeFromISO(iso); }
        });
        return;
      }
      runPauseWithOptionalResumeDate('close', {
        withDateHtml: function() { return null; },
        indefiniteHtml: null
      });
    });
  }
  if (pauseTravelConfirmBtn) {
    pauseTravelConfirmBtn.addEventListener('click', function() {
      var ps = document.getElementById('pauseRefundReasonSelect');
      var inp = pauseTravelResumeInput;
      if (!ps || ps.value !== 'travel_or_move') {
        alert('Please complete the previous step.');
        return;
      }
      if (!inp || !inp.value) {
        alert('Please choose a resume date.');
        return;
      }
      if (inp.min && inp.value < inp.min) {
        alert('Resume date must be at least 1 day ahead.');
        return;
      }
      if (inp.max && inp.value > inp.max) {
        alert('Resume date is too far out for this pause flow.');
        return;
      }
      _pauseSelectedWeeks = pickPauseWeeksForResumeDate(inp.value);
      var resumeLine = formatSuccessResumeFromISO(inp.value);
      runPauseApiRequest('successScreen', '<strong>Resumes automatically:</strong> ' + resumeLine);
    });
  }
  if (pauseTooMuchConfirmBtn) {
    pauseTooMuchConfirmBtn.addEventListener('click', function() {
      var ps = document.getElementById('pauseRefundReasonSelect');
      if (!ps || ps.value !== 'not_eating_enough') {
        alert('Please complete the previous step.');
        return;
      }
      if (!_pauseTooMuchSub) return;
      if (_pauseTooMuchSub === 'reduce') {
        goToPauseMealSelection('pause');
        return;
      }
      var pd = document.getElementById('pauseRefundReasonDetail');
      var detail = 'too_much_food:' + _pauseTooMuchSub;
      detail += '|quantity_change:No';
      if (pd) pd.value = detail.slice(0, 500);
      runPauseWithOptionalResumeDate('successScreen', {
        withDateHtml: function(iso) { return '<strong>Resumes automatically:</strong> ' + formatSuccessResumeFromISO(iso); }
      });
    });
  }
  var pauseScheduleConfirmBtnEl = document.getElementById('pauseScheduleConfirmBtn');
  if (pauseScheduleConfirmBtnEl) {
    pauseScheduleConfirmBtnEl.addEventListener('click', function() {
      var ps = document.getElementById('pauseRefundReasonSelect');
      if (!ps || ps.value !== 'prefer_pause') {
        alert('Please complete the previous step.');
        return;
      }
      if (!_pauseScheduleSub) return;
      if (_pauseScheduleSub === 'reduce') {
        goToPauseMealSelection('pause');
        return;
      }
      var pd = document.getElementById('pauseRefundReasonDetail');
      var detail = 'schedule_change:' + _pauseScheduleSub + '|quantity_change:' + (_pauseScheduleSub === 'reduce' ? 'Yes' : 'No');
      if (pd) pd.value = detail.slice(0, 500);
      runPauseWithOptionalResumeDate('successScreen', {
        withDateHtml: function(iso) { return '<strong>Resumes automatically:</strong> ' + formatSuccessResumeFromISO(iso); }
      });
    });
  }
  var pauseExpensiveConfirmBtnEl = document.getElementById('pauseExpensiveConfirmBtn');
  if (pauseExpensiveConfirmBtnEl) {
    pauseExpensiveConfirmBtnEl.addEventListener('click', function() {
      var ps = document.getElementById('pauseRefundReasonSelect');
      if (!ps || ps.value !== 'too_expensive') {
        alert('Please complete the previous step.');
        return;
      }
      if (!_pauseExpensiveSub) return;
      if (_pauseExpensiveSub === 'reduce') {
        goToPauseMealSelection('pause');
        return;
      }
      var pd = document.getElementById('pauseRefundReasonDetail');
      var detail = 'too_expensive:' + _pauseExpensiveSub + '|quantity_change:' + (_pauseExpensiveSub === 'reduce' ? 'Yes' : 'No');
      if (pd) pd.value = detail.slice(0, 500);
      runPauseWithOptionalResumeDate('successScreen', {
        withDateHtml: function(iso) { return '<strong>Resumes automatically:</strong> ' + formatSuccessResumeFromISO(iso); }
      });
    });
  }
  var pauseFatigueConfirmBtnEl = document.getElementById('pauseFatigueConfirmBtn');
  if (pauseFatigueConfirmBtnEl) {
    pauseFatigueConfirmBtnEl.addEventListener('click', function() {
      var ps = document.getElementById('pauseRefundReasonSelect');
      if (!ps || ps.value !== 'quality') {
        alert('Please complete the previous step.');
        return;
      }
      if (!_pauseFatigueSub) return;
      var pd = document.getElementById('pauseRefundReasonDetail');
      var detail = 'menu_fatigue:' + _pauseFatigueSub;
      if (pd) pd.value = detail.slice(0, 500);
      runPauseWithOptionalResumeDate('successScreen', {
        withDateHtml: function(iso) { return '<strong>Resumes automatically:</strong> ' + formatSuccessResumeFromISO(iso); }
      });
    });
  }
  var pauseDeliveryConfirmBtnEl = document.getElementById('pauseDeliveryConfirmBtn');
  if (pauseDeliveryConfirmBtnEl) {
    pauseDeliveryConfirmBtnEl.addEventListener('click', function() {
      var ps = document.getElementById('pauseRefundReasonSelect');
      if (!ps || ps.value !== 'delivery_issue') {
        alert('Please complete the previous step.');
        return;
      }
      if (!_pauseDeliverySub) return;
      var pd = document.getElementById('pauseRefundReasonDetail');
      var detail = 'delivery_issue:' + _pauseDeliverySub;
      if (pd) pd.value = detail.slice(0, 500);
      runPauseWithOptionalResumeDate('successScreen', {
        withDateHtml: function(iso) {
          return '<strong>Resumes automatically:</strong> ' + formatSuccessResumeFromISO(iso) + '<br><small>For refunds on past deliveries, contact support at customerservice@ufcignite.com.</small>';
        },
        indefiniteHtml: getIndefinitePauseResumeHtml() + '<br><small>For refunds on past deliveries, contact support at customerservice@ufcignite.com.</small>'
      });
    });
  }
  var pauseTryingConfirmBtnEl = document.getElementById('pauseTryingConfirmBtn');
  if (pauseTryingConfirmBtnEl) {
    pauseTryingConfirmBtnEl.addEventListener('click', function() {
      var ps = document.getElementById('pauseRefundReasonSelect');
      if (!ps || ps.value !== 'trying_competitor') {
        alert('Please complete the previous step.');
        return;
      }
      if (!_pauseTryingSub) return;
      var pd = document.getElementById('pauseRefundReasonDetail');
      if (pd) pd.value = ('trying_else:' + _pauseTryingSub).slice(0, 500);
      runPauseWithOptionalResumeDate('successScreen', {
        withDateHtml: function(iso) { return '<strong>Resumes automatically:</strong> ' + formatSuccessResumeFromISO(iso); }
      });
    });
  }
  if (pauseSuccessDone) {
    pauseSuccessDone.addEventListener('click', function() {
      var res = _lastPauseResult;
      closeManagedOverlay(false);
      if (_pauseCallback) _pauseCallback(res || { ok: true, data: {} });
      _lastPauseResult = null;
    });
  }

  window.openPauseModal = function(contractId, customerEmail, callback) {
    _pauseContractId = contractId;
    _pauseCustomerEmail = customerEmail;
    _pauseCallback = callback;
    _cancelCallback = null;
    _cancelResolved = false;
    _pauseSelectedWeeks = 0;
    _pauseMealSelectionUrl = resolvePauseMealSelectionUrl();
    var ps = document.getElementById('pauseRefundReasonSelect');
    var pd = document.getElementById('pauseRefundReasonDetail');
    if (ps) ps.value = '';
    if (pd) pd.value = '';
    _managedModeLock = 'pause';
    if (managedSegment) managedSegment.style.display = 'none';
    resetCancelFlow();
    setManagedMode('pause');
    updatePauseUI();
    if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'CONTINUE'; }
    syncPauseMealSelectionLinks();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  window.openCancelModal = function(contractId, email, cb) {
    _pauseCallback = null;
    _pauseContractId = contractId || '';
    _pauseCustomerEmail = email || '';
    _cancelCallback = cb || null;
    _cancelResolved = false;
    _managedModeLock = 'cancel';
    if (managedSegment) managedSegment.style.display = 'none';
    resetCancelFlow();
    setManagedMode('cancel');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
})();
(function() {
  var reOv = document.getElementById('resumeModalOverlay');
  var reClose = document.getElementById('resumeModalClose');
  var reStay = document.getElementById('resumeModalStay');
  var reConfirm = document.getElementById('resumeModalConfirm');
  var _resumeCb = null;
  function closeResume(confirmed) {
    if (!reOv) return;
    reOv.classList.remove('is-open');
    document.body.style.overflow = '';
    var cb = _resumeCb;
    _resumeCb = null;
    if (cb) try { cb(!!confirmed); } catch (e) {}
  }
  if (reOv) {
    if (reClose) reClose.addEventListener('click', function() { closeResume(false); });
    if (reStay) reStay.addEventListener('click', function() { closeResume(false); });
    if (reConfirm) reConfirm.addEventListener('click', function() { closeResume(true); });
    reOv.addEventListener('click', function(e) { if (e.target === reOv) closeResume(false); });
  }
  window.openResumeModal = function(cb) {
    if (!reOv) {
      if (cb) try { cb(confirm('Are you sure you want to resume this subscription?')); } catch (e) {}
      return;
    }
    _resumeCb = cb || function() {};
    reOv.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
})();

(function() {
  var exOv = document.getElementById('extendPauseModalOverlay');
  var exClose = document.getElementById('extendPauseModalClose');
  var exCancel = document.getElementById('extendPauseModalCancel');
  var exConfirm = document.getElementById('extendPauseModalConfirm');
  var pillsWrap = document.getElementById('extendPauseModalPills');
  if (!exOv || !pillsWrap) return;
  var _extendCb = null;
  var _extendSelected = 1;
  function updateExtendConfirmLabel() {
    if (exConfirm) exConfirm.textContent = 'Confirm Extend (' + _extendSelected + 'W)';
  }
  function closeExtend(weeksOrNull) {
    exOv.classList.remove('is-open');
    document.body.style.overflow = '';
    var cb = _extendCb;
    _extendCb = null;
    if (exConfirm) { exConfirm.disabled = false; }
    if (cb) try { cb(weeksOrNull); } catch (e) {}
  }
  pillsWrap.addEventListener('click', function(e) {
    var pill = e.target.closest('.pause-modal__pill');
    if (!pill) return;
    _extendSelected = parseInt(pill.getAttribute('data-weeks'), 10) || 1;
    pillsWrap.querySelectorAll('.pause-modal__pill').forEach(function(p) {
      p.classList.toggle('is-selected', parseInt(p.getAttribute('data-weeks'), 10) === _extendSelected);
    });
    updateExtendConfirmLabel();
  });
  if (exClose) exClose.addEventListener('click', function() { closeExtend(null); });
  if (exCancel) exCancel.addEventListener('click', function() { closeExtend(null); });
  exOv.addEventListener('click', function(e) { if (e.target === exOv) closeExtend(null); });
  if (exConfirm) {
    exConfirm.addEventListener('click', function() {
      exConfirm.disabled = true;
      closeExtend(_extendSelected);
    });
  }
  window.openExtendPauseModal = function(maxWeeks, cb) {
    var mw = parseInt(maxWeeks, 10);
    if (!isFinite(mw) || mw < 1) mw = 4;
    mw = Math.min(4, Math.max(1, mw));
    _extendCb = cb || function() {};
    _extendSelected = 1;
    pillsWrap.innerHTML = '';
    for (var w = 1; w <= mw; w++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pause-modal__pill' + (w === 1 ? ' is-selected' : '');
      b.setAttribute('data-weeks', String(w));
      b.textContent = w + 'W';
      pillsWrap.appendChild(b);
    }
    updateExtendConfirmLabel();
    if (exConfirm) exConfirm.disabled = false;
    exOv.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
})();
})();
